/* eslint-disable */
/* 当前文件对应的国际化词库版本号: 9.7.1.202610281555 */
export default {
AbandonPaymentConfirm: "確定要放棄付款嗎？",
AboutUs: "關於我們",
AcceptanceScope: "受理範圍",
AccordingTo12306TicketsCanOnlyBePurchasedAfterThePhoneNumberHasBeenVerified: "12306規定，手機號核驗通過方可購票",
AccordingToDiDiComplianceCarServiceNeedsRedirectToDiDi: "根據滴滴合規性要求，用車需跳轉到滴滴平台",
AccordingToYourCompanysTravelPolicy: "根據貴司規定，您未選擇最低價艙位航班",
Account: "我的",
AccountCancel: "帳號註銷",
AccountCancelAssetRightsReminder: "註銷後將放棄帳戶相關的資產權益",
AccountCancelCannotRecoverCaution: "註銷後無法復原帳號，請謹慎操作",
AccountCancelConfirmQuestion: "確認註銷此帳號？",
AccountCancelConfirmReminder: "為保障您的權益，請再次確認：",
AccountCanceled: "帳號已註銷",
AccountLogin: "帳號登入",
AccountName: "戶名",
AccountNotExist: "用戶名不存在",
AccountNumber: "帳單號",
AccountNumber_1: "帳號",
AccountOperations: "綁定手機、修改密碼等",
AccountProtocol: "《帳戶授權協議》",
AccountProtocol_1: "已閱讀並同意《帳戶授權協議》",
AccountProtocol_2: "您提供的姓名、手機號、身份證號等資訊將用於辦理12306帳號密碼找回及進一步認證的便捷服務，更多請查看《帳戶授權協議》",
AccountProtocol_3: "根據《鐵路旅客車票實名制管理辦法》要求，您在使用本平台購買火車票及相關服務時，需提交真實有效的身份證件資訊。該資訊將用於購票、乘車、退改簽、列印發票等出行相關環節。請確保資訊準確無誤，以免影響使用。我們將透過加密等安全措施保護您的個人資訊，僅在必要交易情境下授權提供給相關第三方。更多請查看《個人資訊授權聲明》《火車票預訂須知》",
AccountProtocol_3_key_1: "《個人資訊授權聲明》",
AccountProtocol_3_key_2: "《火車票預訂須知》",
AccountSecurity: "帳號安全",
AccountVerification12306: "12306帳號核驗",
AccountVerification12306Desc: "鐵路局規定購票需要實名制，請選擇以下方式進行核驗",
AccuratelyFillInTheAgeOfEachChildForSpecialOffers: "準確填寫每位兒童的年齡，以便我們為您查找最合適的房型及特價優惠。",
AContactAlreadyExistsWithTheSamePhoneNumber: "已存在相同手機號的聯絡人",
ActivityNotice: "活動通知",
ActivityNoticeDesc: "優惠活動提醒",
ActualPayment: "實付款",
Add: "添加",
AddAnotherTrip: "添加其他車次",
AddBusiness: "新增(因公)",
AddContact: "添加聯絡人",
AddCostCenter: "新增成本中心",
AddDesignatedApprover: "添加指定审批人",
Added: "已添加",
AddEmergencyContact: "添加緊急聯絡人",
AddEmergencyContactPrompt: "添加緊急聯絡人後，當您使用一鍵報警功能，行程資訊會透過簡訊自動分享給緊急聯絡人",
AddFailed: "添加失敗",
AddFlight: "再加一程",
AddFrequentContacts: "新增常用聯絡人",
AddFrequentTraveller: "添加為常旅客",
AddInvoiceHeader: "新增發票抬頭",
AdditionalTaxesFees: "另付稅/費",
AddManually: "手動添加",
AddNewReimbursementInvoiceTitle: "新增報銷發票抬頭",
AddPassenger: "添加乘客",
AddPersonal: "新增(因私)",
Address: "詳細地址",
AddressDistrict: "所在區域",
AddReturnTrip: "添加返程",
AddRoute: "添加行程",
AddSecurityExplain: "添加保障，家人更安心",
AddSecurityExplain_1: "出行有保障，家人更安心",
AddSucceed: "添加成功",
AddTiedList: "添加到已綁列表",
AddTravelCard: "新增常旅卡",
AddTraveler: "添加 +",
AdministrativeDistrict: "行政區",
AdmissionPolicy: "入住政策",
Adults: "成人",
AdultsDesc: ">12周歲(含)",
AfterClickingGoToPay: "點擊去支付後，請打開手機微信的掃一掃，掃描二維碼支付",
AfterClickingGoToPay_1: "點擊去支付後，請打開手機支付寶的掃一掃，掃描二維碼支付",
AfterLanding: "落地後",
AfterSendingTextMessage: "發送短信後，將收到12306發給您的六位數驗證碼，請輸入該驗證碼",
AgentNoResponse: "智能體沒有響應，請稍後再試~",
AggregatedCarService: "聚合用車",
Agree: "同意",
AgreeAndContinue: "同意並繼續",
Agreement: "協議",
AgreementDesc: "協議描述",
AgreementHotels: "合作飯店",
AgreementHotelStarRating: "協議酒店星級",
AgreementHotelTotal: "協議酒店總金額",
AgreementHotelTotalRoomNight: "協議酒店預訂總間夜",
AgreementNight: "協議間夜",
AIAssistant: "AI助手",
AIAssistantAnswering: "AI助手正在回答，請稍後再試",
AIBooking: "AI預訂",
AIFillAssistant: "AI填單助手",
AirChinaPassengerBaggageDomesticTransportationGeneralConditions: "國航旅客行李國內運輸總條件2017版(中文版)",
AirfareYouSearchedFor: "你搜索過的機票",
Airline: "航司",
AirlineList: "航司列表",
AirlinePassengerMaintenance: "航司客規維護中",
AirLowestFareAcceptance: "最低價格票據預訂比例",
Airport: "機場",
AirportDropOff: "送機",
AirportPickup: "接機",
AirportPickupDropoff: "接送機",
AirportStation: "機場车站",
AirportTerminal: "機場航站樓",
AirportTransferService: "接送機服務",
AirRouteAnalysis: "航线分析(仅经济舱)",
AirRouteAndCarrierAnalysis: "航线及承运商分析",
AirTicketBookingInstructions: "機票預訂須知",
AirTicketConsumptionInDifferentCities: "各城市飛機消費情況",
AirTickets: "機票價格",
Aisle: "過道",
AIXiaoShun: "恆順AI助手",
AlarmTripInfoShare: "報警後，行程資訊會透過簡訊自動分享給緊急聯絡人",
Album: "相冊",
AliPay: "支付寶支付",
Alipay: "支付寶",
AlipayAccount: "支付寶帳號",
AlipayAccountFormatError: "支付寶帳號格式不正確",
AlipayAuthDescription: "跳轉到支付寶授權開通企業碼",
AlipayAuthorization: "支付寶授權",
All: "全部",
AllBookings: "我的訂單",
AllCabins: "全部艙位",
AllCollection: "全部收藏",
AllCompanyPayment: "全部公司支付",
AllLoaded: "全部加載完成",
AllOrdersForRecentOneMonth: "已顯示近6個月出差申請單",
AllOrdersForRecentOneYear: "已顯示全部訂單",
AllOrdersForRecentOneYear_1: "已顯示近1年全部訂單",
AllOrdersForRecentSixMonths: "已顯示近6個月全部訂單",
AllowRecordPermission: "請允許訪問錄音權限",
AlreadyHave12306Account: "已有12306帳號",
AlreadySetting: "已設定",
AlsoAvailableBy: "也可選擇",
Amount: "金額",
Amount_1: "金額(含稅)",
AmountOfBillForTheCurrentPeriod: "本期帳單金額",
AmountOfConsumption: "消費金額",
AmountPaidInThisPeriod: "本期已還金額",
AmountPayableInTheCurrentPeriod: "本期應付金額",
AndroidPersonalizedRecommendation: "個性化推薦",
AndroidPersonalizedRecommendationDesc: "提供個性化推薦功能，提升預訂體驗",
AndroidSettingPrivacy: "隱私設定",
Announcement: "公告",
AnnouncementInformation: "公告內容",
Any: "不限",
AnyCity: "不限城市",
Appearance: "外觀模式",
Applicant: "申請人",
ApplicantForRefund: "退票申請人",
Application: "申請",
ApplicationContent: "申請內容",
ApplicationDate: "申請日期",
ApplicationForApproval: "申請審批",
ApplicationForBook: "申請單預訂",
ApplicationIntlFlight: "國際機票申請",
ApplicationIntlHotel: "海外酒店申請",
ApplicationNumber: "申請單號",
ApplicationToReservedNoData: "暫無待預訂的申請單",
Apply: "申請",
ApplyForRefund: "申請退訂",
ApplyRefund: "申請退票",
ApplyRefundOrder: "申請退單",
ApplyReschedule_1: "申請改簽",
ApplyTime: "申請時間",
ApplyTravel: "申請出差",
ApplyTravelCitys: "出差城市",
ApplyTravelConfirm: "出差申請確認",
ApplyTravelNeeds: "出差需求",
ApplyTravelSegment: "行程信息",
ApplyTravelTime: "出差日期",
ApproachingTakeoff: "臨近起飛",
ApprovalExpired: "審核過期",
ApprovalFail: "審查失敗",
ApprovalFlow: "審批流程",
ApprovalInformation: "審核資訊",
ApprovalInformationDesc: "審核狀態提醒",
ApprovalProcess: "審核流程",
ApprovalRejected: "審批駁回",
ApprovalRejection: "審批拒絕",
ApprovalRemarks: "審批意見",
Approvals: "審批",
Approvals_1: "我的審核",
ApprovalSetting: "審批設定",
ApprovalStatus: "審批狀態",
ApprovalSubmitted: "審批已提交",
ApprovalTemplate: "審批範本",
ApprovalTemplate_1: "我的審批範本",
ApprovalTemplateConfig: "審批範本設定",
ApprovalTemplateDetails: "範本詳情",
ApprovalType: "審批方式",
ApprovalType_1: "審批類型",
ApprovalWhitelist: "審批白名單",
Approved: "已審批",
ApprovedCanceled: "申請取消",
ApprovedPass: "審批通過",
Approver: "審批人",
ApproversHaveBeenBound: "已綁定指定審批人",
ApproxPay: "約付",
Area: "面積",
AreYouSureToAddThisAsAFrequentTraveler: "確定將其添加為常旅客？",
AreYouSureToCancelTheOrder: "是否確認取消該訂單？",
AreYouSureToCancelUnableToSave: "目前修改尚未儲存，確定要離開嗎？",
AreYouSureToChange: "是否確認改簽？",
AreYouSureToChangeTheCurrency: "確定更改貨幣？",
AreYouSureToChangeTheLanguage: "確定更改語言？",
AreYouSureToChangeYourFlightToTheCheapestFlight: "請確認是否將您的航班變更為最低價航班？",
AreYouSureToDelete: "是否確認刪除？",
AreYouSureToDeleteTheApprover: "確定刪除該指定審批人？",
AreYouSureToDeleteTheCertificate: "是否刪除該證明？",
AreYouSureToDeleteTheEmployeeFromTheWhitelist: "確定從白名單中刪除該員工？",
AreYouSureToDeleteTheRC: "確定刪除該RC",
AreYouSureToDeleteTheSelectedCollection: "您確認刪除所選收藏嗎？",
AreYouSureToDeleteThisCustom: "確定刪除該自訂項目？",
AreYouSureToDeleteThisEmployeeFromTheTemplate: "確定從範本下刪除該員工？",
AreYouSureToPayForThisOrder: "您確定要支付該訂單嗎？",
AreYouSureToRemoveItFromTheCostCenterList: "確定刪除該成本中心？",
AreYouSureToRemoveItFromTheDepartmentsList: "確定刪除該部門？",
AreYouSureToRemoveItFromTheEmployeeList: "確定將其從員工列表中刪除？",
AreYouSureToRemoveItFromTheFrequentTravelerList_1: "確認要將其移出常旅客清單嗎？（此操作僅會將該旅客自您的個人常用清單中移除，並非刪除其職員資料。若需刪除職員資料，請前往【管理-職員管理】進行操作，或聯絡您的專屬差旅顧問。）",
AreYouSureToRemoveItFromTheFrequentTravellerList: "確認將其從常旅客列表中移除？",
AreYouSureToRemoveItFromTheNonEmployeeList: "確定將其從外部人員列表中刪除？",
AreYouSureToRescheduled: "是否確認改期？",
AreYouSureToSeat: "是否確認選座？",
AreYouSureToSubmit: "是否確認提交？",
AreYouSureToSubmitAndPayForTheOrder: "是否確認提交並支付訂單？",
AreYouSureToSubmitYourOrder: "是否確認提交訂單？",
AreYouSureToTurnOffFaceIDLogin: "確定關閉面容登入？",
AreYouSureYouWantToDeleteThisAccount: "確認要刪除該帳戶嗎？",
AreYouSureYouWantToLogout: "確認要退出該帳戶嗎？",
AreYouSurYouWantToDeleteThisAccount: "確定要刪除該帳戶嗎？",
AreYouSurYouWantToLogout: "確定要退出該帳戶嗎？",
AreYouSurYouWantToUntieThisAccount: "您確定要解綁該帳號嗎？",
Arrival: "抵達",
ArrivalCity: "抵達城市",
ArrivalCityAddress: "目的地",
ArrivalCityAddressDesc: "出差途經城市皆需添加至目的地",
ArrivalCityOptions: "可選到達城市",
ArrivalDate: "抵達日期",
ArrivalEarliest: "抵達時間（最早至最晚）",
ArrivalLatest: "抵達時間（最晚至最早）",
ArrivalStation: "抵達車站",
ArrivalStation_1: "抵達站",
ArrivalTerminal: "抵達航站樓",
ArrivalTime: "抵達時段",
ArrivalTime_1: "抵達時間",
ArrivalTime_2: "抵達站/時間",
ArrivalTimeDepartureDate: "抵達時間/退房日期",
ArrivalTimeIsLocalTime: "抵達時間為當地時間",
Arrive: "送達",
ArriveAddress: "下車地點",
Associated12306Account: "關聯12306帳號",
AtNoonToday: "今天中午",
AttachFile: "附件",
AttachFileUploadExplain_1: "·最多可以上傳10個檔案，每個檔案大小不超過8M",
AttachFileUploadExplain_2: "·支援的檔案類型有img、word、ppt、excel、pdf",
AUD: "澳元",
Authentication: "身份驗證",
AuthenticationProtocol: "《認證協議》",
AuthenticationProtocol_1: "已閱讀並同意《認證協議》",
AuthResultNotFound: "暫未取得授權結果，請確認是否已在支付寶完成開通",
AutoCorrect: "自動更正",
AutoCorrectIdentityInfo: "已依據身份證自動修正以下內容",
Available: "可用",
AvailableIntegral: "可用積分",
AvailableTickets: "有票",
AverageBusinessTravelFare: "商旅平均票價",
AverageDiscount: "平均折扣",
AverageDomesticDiscount: "國內平均折扣(經濟艙)",
AverageHotelPrice: "酒店均價",
AverageMileagePrice: "里程均價(僅經濟艙)",
AverageNumberOfDaysBookedInAdvance: "平均提前預訂天數",
AveragePrice: "平均價格",
AveragePriceOfBusinessTravelAgreement: "商旅協議均價",
AveragePriceOfBusinessTravelMileage: "商旅里程均價",
AverageTicketPrice: "平均票價",
AverageTrainTicketPrice: "火車票均價",
AVerificationMessagePleaseEnterTheVerificationCodeYouReceived: "發送了一封驗證簡訊，請輸入您收到的驗證碼",
AvgTicketPriceOfMileage: "里程均價",
AwaitingConfirmation: "待定",
AwayFrom: "距離",
Baby: "嬰兒",
BabyDesc: "14天(含)-2周歲(不含)",
BabyNonBookable: "嬰兒不可訂",
BabyNonSupportBookable: "如需預訂嬰兒票，請聯絡您的差旅顧問",
BabyReQuery: "該航班嬰兒不可訂，如需攜帶嬰兒出行，請重新查詢可訂航班",
BabyTooSmallNonBookable: "出生不滿14天的嬰兒不可預訂",
BabyWith: "帶嬰兒",
BabyYearsOld: "14天-2歲",
Back: "返回",
BackFlight: "返程航班",
BackModify: "返回修改",
BackToHome: "返回首頁",
BackToHotelList: "返回酒店列表",
BackToLogin: "返回登入頁面",
Baggage: "行李",
BaggageCarousel: "行李轉盤",
BaggagePolicy: "行李規定",
Balance: "餘額",
Bank: "開戶銀行",
BankAccount: "帳戶",
BankCardInformation: "信用卡資訊",
BasicInformation: "基本資訊",
BasicInformationIsIncompletePleaseEdit: "基本資訊不全，請編輯",
Batch: "批量管理",
BatchInvoiceIssuing: "批量開具",
BatchPass: "批量通過",
BedType: "床型",
BeforeUsingDiDiPlatformPleaseFillCarBookingOrder: "在前往滴滴平台叫車前，需填寫用車預訂單",
BeijingTime: "北京時間",
BeingApprovalByTheFlightCompany: "待航司審核",
BeingVerified: "正在核驗",
BelongCity: "所屬城市",
BeOverdueByCarPleaseCheckAgain: "車輛資訊可能有變，請重新查詢",
BeOverdueByFlightPleaseCheckAgain: "航班可能有變，請重新查詢",
BeOverdueByHotelPleaseCheckAgain: "酒店資訊可能有變，請重新查詢",
BeOverdueByTrainPleaseCheckAgain: "車次可能有變，請重新查詢",
BigBed: "大床",
BillEndDate: "帳單終止日",
BillGrouping: "帳單分組",
BillingPeriod: "帳單帳期",
BillStartDate: "帳單起始日",
Bind: "立即綁定",
BindFailed: "綁定失敗",
Binding: "綁定",
BindingCTrip: "攜程會員綁定",
BindingCTripDesc: "我們將使用您輸入的手機號碼綁定攜程旅行個人會員，若您尚未成為攜程會員，恒順商旅將使用該手機號碼為您註冊攜程會員。",
BindingCTripPrivacy: "閱讀並同意攜程的《服務協議》和《隱私政策》",
BindingCustomItems: "綁定自定義項",
BindingEmployees: "綁定員工",
BindingHuazhu: "華住會員綁定",
BindingHuazhuDesc: "我們將使用您的資訊與華住協議單位進行綁定，若您尚未成為華住會員，恒順商旅將使用該資訊為您註冊華住會員。",
BindingHuazhuPrivacy: "閱讀並同意華住的《服務協議》和《隱私政策》",
BindingLogin: "一鍵授權綁定",
BindingMeituan: "美團會員綁定",
BindingMeituanDesc: "我們將使用您的資訊與美團協議單位進行綁定，若您尚未成為美團會員，恒順商旅將使用該資訊為您註冊美團會員。",
BindingMeituanPrivacy: "閱讀並同意美團的《服務協議》和《隱私政策》",
BindingStatus: "綁定狀態",
BindMailbox: "綁定郵箱",
BindMembersToEnjoyLowerPrices: "綁定會員立享更低價格",
BindSuccessfully: "綁定成功",
BindUnbind: "綁定/解除綁定",
BlankImport: "空白導單",
BoardingGate: "登機口",
Book_1: "訂票",
Book_2: "立即預訂",
Book_3: "預 訂",
BookableNights: "可預訂間夜數",
BookableTimes: "可預訂次數",
BookAllStaff: "為全部員工預訂",
BookCar: "預訂車輛",
BookDesignatedDepart: "為指定部門預訂",
BookDesignatedStaff: "為指定員工預訂",
BookDomesticFlights: "預訂國內機票",
BookDomesticHotel: "預訂國內酒店",
Booker: "預訂人",
BookFinished: "訂完",
BookFlight: "預訂機票",
BookHotel: "預訂酒店",
BookInAdvance: "提前預訂",
Booking: "預訂",
BookingApprovalFlow: "預訂審批流",
BookingDaysInAdvance: "提前預訂天數",
BookingInformation: "預訂資訊",
BookingInstructionsAndInstructionsForReturning: "預訂須知和退改說明",
BookingLevel: "預訂級別",
BookingMail: "預訂郵件",
BookingMethods: "預訂方式",
BookingPwd: "預訂密碼",
BookingRange: "預訂範圍",
BookingSMS: "預訂簡訊",
BookingSource: "預訂來源",
BookingSucceed: "預訂成功",
BookingTheBus: "預訂汽車票",
BookingTheCar: "預訂用車",
BookingTheMeals: "預訂用餐",
BookInternationalFlights: "預訂國際機票",
BookInternationalHotel: "預訂海外酒店",
BookOnlySelf: "僅限幫本人預訂",
BookPermissions: "預訂權限",
BookPwdAbandon: "放棄",
BookPwdContinuePayment: "繼續付款",
BookPwdSetPasswordFormatError: "請輸入六位數字密碼",
BookPwdSetPasswordHint: "請輸入六位數字",
BookTheLowestLogicalFare: "預訂最低價",
BookTrain: "預訂火車票",
BookType: "預訂類型",
Bound: "已綁定",
BoundCustomItems: "已綁自訂項",
BoundEmployees: "已綁員工",
Brand: "品牌",
BrandSlogan: "出行選恒順，更順暢、更貼心",
Breakfast: "含早",
Breakfast_1: "早餐",
BrowserOpens: "瀏覽器打開",
Budget: "預算",
BudgetAmount: "預算金額",
BudgetColon: "預算：",
BulkRejection: "批量拒絕",
Business: "因公",
BusinessCenter: "商務中心",
BusinessClass: "公務艙",
BusinessConsultant: "業務顧問",
BusinessConsumptionNoPersonalPayment: "您需要開通支付寶企業碼，才能在恆順商旅預訂火車票時使用「企業代付」，無需個人墊資",
BusinessDistrict: "商業區",
BusinessDistrictInfrastructureBrandEtc: "商圈/基礎設施/品牌 等",
BusinessReschedule: "因公改期",
BusinessTravel: "商旅",
BusinessTravelScale: "企業差旅規模(月度)",
BusinessTrip: "因公出行",
BusinessTripApply: "出差申請",
BusinessTripFormGenerated: "出差申請單已生成",
BusinessTripFormTravelInfo: "出差申請單（行程資訊）",
BusinessTripSchedule: "出差行程",
BusinessType: "業務類型",
BusinessType_1: "業務",
BusinessUnit: "業務單位",
BusOrderConfirmation: "汽車票訂單確認",
BusOrderDetails: "汽車票詳情",
BusRank: "汽車票差標",
BusRefundOrderConfirm: "汽車票退票訂單確認",
BusStation: "汽車站",
BusTicket: "汽車票",
BusTicketOrder: "汽車票訂單",
ByMail: "通過郵箱",
ByPhoneNumber: "通過手機號碼",
Cabin: "艙等",
CabinInformationHasBeenUpdated: "倉位信息已更新，訂單部分內容可能發生變動，請重新填寫訂單以確保準確性",
CabinLevel: "艙位等級",
CabinType: "艙位類型",
CAD: "加拿大元",
Calendar: "日曆",
CallCar: "叫車",
CallCarNow: "立即叫車",
CallingCarCancelConfirm: "正在全力為您呼叫車輛，確定取消用車嗎？",
CallingForYou: "正在為你呼叫...",
CallingVehicleForYou: "正在為您呼叫車輛",
CallPhone: "打电话",
CallTaxiAgain: "重新打車",
CallThePolice: "110 報警",
Camera: "拍攝",
CameraPermissionRetryMessage: "目前需要使用相機權限，是否再次開啟？",
CameraPermissionSettingsMessage: "相機權限未開啟，請前往系統設定開啟。",
CameraPermissionUsageMessage: "用於取得影像資訊，支援掃碼、拍照和人臉辨識等功能。",
CameraPermissionUsageTitle: "相機權限使用說明",
Cancel: "取消",
Cancel_1: "暫不升级",
Cancel_2: "取消管理",
CancelAnyway: "仍要取消",
Canceled: "已取消",
CancelFailed: "取消失敗",
CancelFee: "取消費用",
CancelForFree: "免費取消",
CancelInformation: "取消資訊",
CancelInquiry: "取消需求單",
Cancelling: "正在取消",
CancelOrder: "取消訂單",
CancelReason: "取消原因",
CancelRefund: "取消退票",
CancelRoomSelectTitle: "選擇要取消的房間",
CancelRules: "取消規則",
CancelSucceed: "取消成功",
CannotBeCancelled: "不可取消",
CannotBeConvertToPinyin: "未填寫中文名，不可轉拼音",
CannotOpenAlipayUseQRCode: "無法直接開啟支付寶？請使用二維碼完成支付",
CannotSelectGuestRepeat: "不能重複選擇入住人",
CanNotSupportedFileType: "暫不支持該文件類型，請重新選擇",
Car: "用車",
CarAirport: "機場接送",
CarApplication: "用車申請",
CarbonEmission: "碳排放量",
CarbonOffset: "碳补偿(种植棵树)",
CardHolder: "持卡人",
CardholderInformation: "持卡人信息",
CardNumber: "卡號",
CardType: "卡類型",
CarFare: "使用車票價格",
CarOrder: "用車訂單",
CarOrderConfirmation: "用車訂單確認",
CarPlatform: "用車平台",
CarRank: "用車差標",
Carrier: "承运人",
Carrier_1: "承運商",
CarrierAnalysis: "承運商分析",
CarriersItineraries: "承運商及航線",
CarScene: "用車場景",
CarServiceTime: "用車時間",
CarTrain: "火車接送",
CarType: "用車類型",
CellphoneNumber: "手機號碼",
CertificateInformation: "證件資訊",
Change: "改簽",
Change_3: "切换 12306账号",
ChangeDetails: "改期明細",
ChangeDetails_1: "改签明细",
ChangeFaceCheck: "切换人脸核验",
ChangeFailed_1: "修改失敗",
ChangeFee: "改簽費",
ChangeFlight: "修改航班",
ChangeFlightSchedule: "改期航班",
ChangeIDNoVerify: "切换证件号码核验",
ChangeInstructions: "改簽規則",
ChangeLoginPwd: "修改登入密碼",
ChangeMobileNumber: "更換手機號",
ChangeMobileNumber_1: "更 換 手 機 號",
ChangePassword: "修改密碼",
ChangePolicy: "更改規定",
ChangeRate: "改簽率",
ChangeSchedule: "改簽行程",
ChangeSegment: "更改行程",
ChangeSegmentDate: "我要改期",
ChangeSmsCheck: "切換簡訊核驗",
ChangeStation: "變更到站",
ChangeStationTitle: "車站變更提示",
ChangeSuccessFailed: "改簽失敗",
ChangeYourFlightAndContinueDeparting: "換個航班，繼續出發~",
Changing: "改簽中",
Charge: "收費",
ChargebackDateTime: "退單申請時間",
ChargebackDetails: "退單詳情",
ChargebackNumber: "退單號",
ChargebackRoom: "取消間數",
ChargebackTime: "取消日期",
ChargeByAirlineRefundRules: "按航空公司退改規則收費",
ChargedAccordingToTheCorrespondingAirlineTicketRegulations: "根據相應航空公司客票規定(NFD)收取",
CheapestFlight: "最低價航班",
CheapFlights: "特價機票",
Check: "核驗",
CheckerInformation: "入住人資訊",
CheckIn: "入住",
CheckInAppOpenOrDownloadTips: "已安裝請點擊「打開」；未安裝請點擊「前往下載」，安裝後再辦理值機。",
CheckInCity: "入住城市",
CheckInCounter: "值機櫃台",
CheckInCounterIsClosedNotBookedYet: "值機櫃台已關閉，暫不預訂",
CheckInDate: "入住日期",
CheckInformation: "核對資訊",
CheckingForTheLatestPriceForYou: "正在為你查詢最新價格，請稍後...",
CheckInHotel: "入住酒店",
CheckInRules: "入住規則",
CheckInSeat: "值機選座",
CheckInTime: "入住時間",
CheckInViaAppBelow: "您可透過下方 App 辦理值機。",
CheckOrder: "查看訂單",
CheckOut: "離店",
CheckOutDate: "離店日期",
CheckRemainRoomType: "查看剩餘房型",
CheckTheCancellationRules: "查看取消規則",
CheckTheDifference: "點擊查看差標詳情",
CHF: "瑞士法郎",
ChildOfAge: "兒童年齡",
Children: "兒童",
ChildrenAndBabyExplain: "兒童嬰兒預訂說明",
ChildrenDesc: "2週歲(含)-12週歲(不含)",
ChildrenNonBookable: "兒童不可訂",
ChildrenNonSupportBookable: "如需預訂兒童票，請聯繫您的差旅顧問",
ChildrenReQuery: "該航班兒童不可訂，如需攜帶兒童出行，請重新查詢可訂航班",
ChildrenWith: "帶兒童",
ChildrenYearsOld: "2-12岁",
China: "國内",
China_1: "国内(含港澳台) 目的地",
China_3: "中國",
ChinaRegion: "國內(含港澳台)",
ChinaSouthernAirlinesNewRegulations: "南航新規提醒：乘客可通過南航app和微信退改本人机票，並可直接獲取退票款。如乘客私自到南航退款，我司將仍按原訂機票款費用向貴司全額收取。提醒貴司做好監管，否則存在風險。",
ChineseName: "中文姓名",
Choose: "選擇",
ChooseAirport: "選擇機場",
ChooseBU: "選擇BU",
ChoosePhotos: "選擇照片",
ChooseSnatchSeat_1: "选择高铁/动车/城际座席",
ChooseSnatchSeat_2: "選擇普快/特快/其他座席",
ChooseTheLowestPriceToSave: "選擇最低價格节省",
ChooseTheReason: "選擇原因",
ChooseTrainStation: "選擇火車站",
CICO: "入離日期",
CICO_1: "入離店日期",
City: "城市",
City_1: "按起降城市",
CityAnalysis: "城市分析",
ClassAnalysis: "舱位分析",
ClassHotel: "酒店型",
ClassRoomTypeSeat: "舱等/房型/座席",
Clear: "清空",
ClearAllChat: "清除所有對話",
ClearCache: "清除緩存",
ClearFilters: "清空條件",
ClearHistory: "清空歷史記錄",
ClearHistorySearchRecord: "清空歷史搜索記錄",
ClearHistorySearchRecordConfirmTip: "清空記錄後無法恢復，是否清空歷史搜索記錄？",
ClearSuccess: "清除成功",
ClickLogin: "点击登录",
ClickNextToIndicateThatYouHaveAcceptedAndAreAwareOfTheRefundPolicyForThisTicket: "點擊「下一步」即表示您已接受並知悉此機票的退改簽規則",
ClickOptionToChangeDropOffPoint: "点击选项可更改下车点",
ClickOptionToChangePickUpPoint: "点击选项可更改上车点",
ClickRefresh: "点击刷新",
ClickShrink: "點擊收起",
ClickToCopyShareCode: "點擊複製吱吱碼",
ClickToDownloadApp: "APP 下载请点击",
ClickToOpen: "点击打开",
ClickToResend: "点击重新发送",
ClickToSetTheAddress: "点击设置地址",
ClickToView: "點擊查看",
Close: "關閉",
Closed: "已關閉",
CloudBill: "雲帳單",
CloudQuickPay: "雲閃付",
CO2Emissions: "碳排放",
CodeShare: "共享",
Collect: "收藏",
ComfortHotel: "舒適型酒店",
ComfortHotel_1: "舒適",
CommentsDetails: "詳細評論",
CommodityDetails: "商品詳情",
CommonAddress: "常用地址",
CommonOperations: "常用操作",
Company: "公司",
CompanyInfo: "單位信息",
CompanyInvoiceHeader: "公司抬头",
CompanyName: "企業名稱",
CompanyPayment: "公司支付",
CompanyPaymentPrepay: "公司支付(預付款)",
CompanyTel: "公司聯絡電話",
CompleteVerification: "完成核驗",
ComprehensiveTravelSafety: "全方位保障您的出行安全",
Confirm: "確定",
Confirm_1: "確認",
Confirm_2: "選好了",
Confirm_3: "確 定",
ConfirmAndNext: "確認並繼續",
ConfirmationOfFirstTimeBookingInformationForPassenger: "乘機人首次預訂信息確認",
ConfirmationOfFirstTimeBookingInformationForPassengerDesc: "為確保行程順利，請仔細核對並確認出行人資訊。若資訊有誤，請點擊「去修改」進行調整。",
ConfirmationOfFirstTimeBookingInformationForPassengerVehicle: "乘車人首次預訂信息確認",
ConfirmationOrder: "確認單",
ConfirmCancel: "確定取消",
ConfirmClearAllChat: "是否要清除所有對話記錄？",
ConfirmCopyRedirectLink: "是否確認複製跳轉連結？",
ConfirmDelete: "確認刪除",
ConfirmDeleteInvoiceTitle: "確定要刪除該发票抬头吗？",
ConfirmDeparture: "確定退出",
ConfirmDropOffPoint: "確認下车点",
Confirmed: "已確認",
ConfirmedCallCar: "已確認，立即叫車",
ConfirmedCheckInTimeAtTheCounterCanBeBooked: "已到柜台确认值机时间，继续预订",
ConfirmedRedirectToDiDiCarHailing: "已確認，跳轉至滴滴叫車",
ConfirmImmediately: "立即確認",
Confirming: "中確認",
ConfirmMail: "確認郵件",
ConfirmPay: "確認支付",
ConfirmPickUpPoint: "確認上车點",
ConfirmPoint: "確認選點",
ConfirmRules: "確認規則",
ConfirmSelection: "選擇確認",
ConfirmSMS: "確認短信",
ConfirmStartReserveSeat: "是否確認發起佔座？",
ConfirmSubmission: "確認提交",
ConfirmThatYourDiDiAccountIsLinked: "確認已绑定滴滴账户？",
ConfirmTheChanges: "確認修改",
ConfirmTheChanges_1: "確 修 認 改",
ConfirmTheNewPassword: "確認新密碼",
ConfirmTheNewPassword_1: "密碼確認",
ConfirmTheRemovalOfTheirDocuments: "確認將其證件移除?",
ConfirmToResendApprovalInformation: "是否確認重發審批信息?",
ConfirmUnbindEnterpriseCode: "解除綁定後，您將不能再使用企業碼支付。確定要解綁嗎？",
ConfirmUnbinding: "確認解綁？",
ConfirmUpdate: "確認更新",
ConfirmVoucherContent: "確認憑證內容",
ConsistentWithIdPinyin: "與證件所示拼音一致",
Consultant: "專屬顧問",
ConsumptionOfCarsInDifferentCities: "各城市用車消費情況",
ConsumptionOfTrainTicketsInEachCity: "各城市火車票消費情況",
ContactAdministratorToEnable: "聯繫管理員開通~",
ContactCustomerService: "聯繫客服",
ContactDetails: "聯絡人詳情",
ContactDriver: "聯繫司機",
ContactHotel: "聯絡酒店",
ContactInfo: "聯絡方式",
ContactInformation: "聯絡人信息",
ContactName: "聯絡人姓名",
ContactNumber: "聯絡電話",
ContactNumberColon: "聯絡電話：",
ContactPhoneNumber: "聯絡手機號碼",
ContactPhoneNumberCannotBeDuplicated: "聯絡手機號碼不能重複",
Contacts: "聯絡人",
ContactsPermissionRetryMessage: "目前需要使用通訊錄權限，是否再次開啟？",
ContactsPermissionSettingsMessage: "通訊錄權限未開啟，請前往系統設定開啟。",
ContactsPermissionUsageMessage: "用於從通訊錄中選擇聯絡人，並取得您主動選擇的聯絡人資訊。",
ContactsPermissionUsageTitle: "通訊錄權限使用說明",
ContactUsByPhoneIfFaceRecognitionFails: "如果無法進行面部辨識可以電話聯繫我們",
Content: "內容",
ContentIsEmpty: "內容為空",
Continue: "繼續",
ContinueBooking: "繼續預訂",
ContinueBooking_1: "繼 續 預 訂",
ContinueBookingFlightTicket: "繼續預訂機票",
ContinueBookingHotel: "繼續預訂酒店",
ContinueBookingTrainTicket: "繼續預訂火車票",
ContinueBookingWithoutRescheduling: "不改期，繼續預訂",
ContinueFlightTicketInquiry: "繼續機票詢價",
ContinueInput: "繼續填寫",
ContinueIssuingInvoice: "繼續開票",
ContinueManualChange: "繼續人工改簽",
ContinueManualRefund: "繼續人工退票",
ContinueReserveCar: "繼續預約用車",
ContinueRide: "繼續用車",
ContinuetoBook: "繼續預訂原航班",
ContinueToChange: "繼續改簽",
ConvertToPinyin: "轉拼音",
Copy_1: "複製",
CopyFailed: "複製失敗",
CopyInvitationInformation: "複製邀請信息",
CopyInvitationLink: "複製邀請連結",
CopyLink: "複製PDF連結",
CopyLinkToBrowserForPay: "若支付未正常跳轉，請複製下方連結至 Safari 或瀏覽器完成支付",
CopyLinkToSafariOrBrowser: "請複製連結至 Safari 或預設瀏覽器開啟支付",
CopyShareCodeToAlipay: "複製吱吱碼到支付寶",
CopySuccess: "已複製到剪貼板",
CopySuccessPasteInAlipay: "複製成功，請在支付寶中貼上開啟",
CopyTheLink: "複製連結",
CopyToClipboard: "複製到剪貼板",
CorporateTourism: "企業旅遊",
CostCenter: "成本中心",
CostCenterName: "成本中心名稱",
CreationDate: "創建日期",
CreationTime: "創建時間",
Credential: "證件",
CreditCard: "信用卡",
CreditCardGuarantee: "信用卡擔保",
CreditGuarantee: "信用擔保",
CrisisPoliceHelp: "遇到危機，請向警方求助",
CrossRegionCarHailing: "跨區叫車",
Currency: "貨幣",
CurrencySelectedIncorrectly: "选择币种有误，请重新选择",
CurrencySetting: "货币设置",
Current: "當前",
CurrentAdvancePayment: "當前預付款",
CurrentAvailable: "目前可用",
CurrentCityNoCarService: "當前城市該時段暫未提供服務",
CurrentFld: "當前可用代金豆數量",
CurrentIntergral: "當前积分",
CurrentLocatedCity: "目前所在城市",
CurrentLocation: "當前位置參考",
CurrentLocationReference: "當前位置（仅供参考）",
CurrentLxd: "當前可用旅行豆數量",
CurrentlyBusiness: "當前只開通了因公查詢",
CurrentlyOnlineInsuranceOnlySupportsTheFirstSegment: "目前線上保險僅支持購買第一程",
CurrentlyOnlyDomesticAirTickets: "目前只支持国内机票。违反机票差旅标准，需要选择的原因",
CurrentlyPrivate: "當前只開通了因私查詢",
CurrentMobile: "當前手機號：",
CurrentPageDownload: "當前頁下載",
CurrentPassword: "當前密碼",
CurrentPosition: "當前位置(仅供参考)",
CurrentSelectedLocation: "當前選中位置",
CurrentVersion: "當前版本",
Custom: "自定义",
CustomerChoosesThePrice: "客戶選擇價格",
CustomerExperienceFirst: "客戶體驗第一",
CustomerServiceSupport: "客戶服務支持",
CustomItems: "自定义项",
CustomizationsBound: "已绑定自定义项",
CustomUseFld: "自定义使用代金豆数量",
CustomUseLxd: "自定义使用旅行豆数量",
DangerHelp: "遇到危險，請向警方求助",
Dark: "深色模式",
DataUpTo: "數據更新至",
Date: "日期",
DateIsTheLocalDateOfDepartureCity: "您選擇的是城市出发的当前日期",
DateOfBirth: "出生日期",
DateOptions: "可選日期",
DeductionLxd: "抵扣",
DeductionRequired: "需扣款",
Default: "默认",
Delete: "刪除",
Delete_1: "移除",
DeleteFollow: "取消訂閱",
DeleteFrequentFlyer: "刪除常旅客",
DeleteLocation: "刪除該地點",
DeleteSuccessFailed: "刪除失敗",
DeleteSuccessful: "刪除成功",
DeleteTrip: "刪除行程",
DeliveryAddress: "配送地址",
DeliveryAfterSuccessfulBooking: "預訂成功後送",
DeliveryCity: "送達城市",
DeliveryInfo: "配送信息",
DeliveryMethod: "配送方式",
DepartingColon: "去:",
DepartingNow: "現在出发",
Department: "部門",
DepartmentName: "部門名稱",
DepartTime: "出发时间",
Departure: "出发",
Departure_1: "車上地點",
DepartureCity: "出发城市",
DepartureCityAddress: "出发地",
DepartureCityAndArrivalCityCannotBeSame: "城市和城市不能相同",
DepartureCityOptions: "可選擇發城市",
DepartureDate: "出发日期",
DepartureDateLocation: "出发日期(当地时间)",
DepartureDateOptions: "可選擇發日期",
DepartureEarliest: "從早到晚",
DepartureEarliest_1: "出发从早到晚",
DepartureLatest: "從晚到早",
DepartureLatest_1: "出发从晚到早",
DepartureStation: "出发车站",
DepartureTerminal: "出发航站楼",
DepartureTime: "出发时段",
DepartureTime_1: "出发站/时间",
DepartureTime_2: "起飛時間",
DepartureTime_3: "起飛時間段",
DepartureTimeCheckInDate: "出发时间/入住日期",
DescribeYourNeeds: "您可以述說需求，我將全力滿足哦~~",
DesignateApprover: "指定審批人",
DestinationOptions: "可選目的地",
Detail: "明細",
Details: "詳情",
Details_1: "查看詳情",
DetectedNewVersion: "檢測到新版本",
DidiDriverIsComing: "車手正在趕來",
DiDiTravel: "滴滴出行",
DifferentFromTheDepartingAirport: "與去程機場出发不同",
DifferentFromTheOriginalScheduledArriveAirport: "與原訂行程到達機場不同",
DifferentFromTheOriginalScheduledDepartureAirport: "與原訂行程出發機場不同",
DifferentFromTheOriginalScheduledDepartureAndrArriveAirport: "與原訂行程出發機場和到達機場不同",
DiffPrice: "差價",
Dimension: "分析維度",
Dimension_1: "多維度分析",
Diner: "用餐人",
DinerDetail: "用餐人詳情",
DinerInfomation: "用餐人信息",
DinerName: "用餐人姓名",
Dingtalk: "釘釘",
DingTalkByAccount: "釘釘账号",
DingTalkByUser: "釘釘員工綁定",
Direct: "直達",
DirectFlightFirst: "直飛優先",
DirectionsForUse: "使用說明",
DirectlyOpenAlipay: "直接打開支付寶",
Disagree: "不同意",
DiscountDistribution: "折扣分布",
DiscountInterval: "折扣区间",
DisplayTicketPrice: "顯示票價",
DistanceLowToHigh: "直線距離近-遠",
DistanceNearToFar: "按距離從近到遠",
DocumentDetails: "材料詳情",
DocumentInformationVerificationFailed: "證件信息核驗未通過",
DocumentSignatory: "證件簽署國",
DomAverageDiscount: "国内平均折扣(仅经济舱)",
DomesticFlights: "國內機票",
DomesticFlights_1: "國內機票(不含港澳台地區)",
DomesticFlightsApplication: "國內機票申請",
DomesticFlightsOrderConfirmation: "國內機票訂單確認",
DomesticHotel: "國內酒店",
DomesticHotel_1: "國內酒店(含港澳台地區)",
DomesticHotelApplication: "國內酒店申請",
DomesticHotelOrderConfirmation: "國內酒店訂單確認",
DomesticHotelOrders: "國內酒店訂單",
DomesticServicePhone: "境內服務熱線",
DomesticTicketChange: "國內機票改期",
DomesticTicketChangeApplication: "國內機票改期申請",
DomesticTicketOrder: "國內機票訂單",
DomesticTicketRefundApplication: "國內機票退票申請",
DomFullFareTicketRate: "国内全价票比例",
DoNotChange: "不可更改",
DoNotChangeBack: "不可退改",
DoNotChooseForNow: "暫不選擇",
DoNotUse: "暫不使用",
DoNotUseFld: "暫不使用代金豆",
DoNotUseLxd: "暫不使用旅行豆",
DoubleSIMDeviceTip: "當前設備為雙卡設備，請注意選擇號碼發送短信",
Download: "下載",
DownloadAll: "全部下載",
Downloaded: "已下載",
DownloadFailed: "下載失敗",
DownloadPolicy: "下載保單",
DownloadSchedule: "下載明細表",
DownloadTemplate: "下載模板",
DownloadTheQRcode: "下載二維碼",
DowntownCenter: "市中心",
DoYouWantToLeaveHumanCustomerService: "是否離開人工客服",
DoYouWantToSwitchToPerson: "是否切換至個人帳號？",
DoYouWantToSwitchToUnit: "是否切換至單位帳號？",
DragMapToSetPoint: "拖動地圖選點設定",
DrillMultipleChoice: "鑽級(可多選)",
DriverArrival: "司機已到達",
DriverArrivedCancelConfirm: "司機已經到達上車點，確定取消用車嗎？",
DriverArriving: "司機正在努力趕來...",
DriverComingCancelConfirm: "司機正在努力趕來，確定取消用車嗎？",
DriverPriorityContact: "請優先聯繫司機",
DropDownToViewHistory: "下拉查看歷史訊息",
DropOffCity: "下車城市",
Duration: "行程用時",
DutyParagraph: "公司稅號",
DwellTime: "停留時間",
Dysfunction: "功能異常",
EarlyThisMorning: "今天凌晨",
EarlytoLate: "起飛時間 早-晚",
EconomicHotel: "經濟型酒店",
EconomicHotel_1: "經濟",
EconomyClass: "經濟艙",
Edit: "編輯",
EditContact: "修改聯絡人",
EditContactFailed: "修改聯絡人失敗",
EditCostCenter: "編輯成本中心",
EditDepartment: "編輯部門",
EditFrequentContact: "編輯常用聯絡人",
EditInvoiceHeader: "編輯發票抬頭",
EditRC: "編輯RC",
Effective: "已生效",
EffectiveDate: "證件有效期",
ElectronicInvoice: "電子發票",
Email: "電子郵箱",
EmailAddress: "電子郵箱地址",
EmailAddress_1: "電子郵箱",
EmailApproval: "郵件審批",
EmailCannotBeEmpty: "電子郵箱不能為空",
EmailChineseOrEnglishForFlight: "·中／英版確認郵件（中／英版機票確認單PDF附件）",
EmailChineseOrEnglishForTrain: "·中／英版確認郵件（中／英版火車票確認單PDF附件）",
EmailFormatIsIncorrect: "電子郵箱格式不正確！",
EmergencyContact: "緊急聯絡人",
EmergencyContactMobile: "緊急聯絡人號碼",
EmergencyContactName: "緊急聯絡人姓名",
EmergencyContactNumber: "緊急聯絡電話",
EmergencyHelp: "緊急求助",
Emission: "排放量(kg)",
EmployeeDetails: "員工詳情",
EmployeeInformation: "人員信息",
EmployeeManagement: "員工管理",
EmployeeNumber: "員工數",
EmployeesCanApply: "員工訪問連結可申請加入團隊",
EmployeesCcanScan: "員工可掃描 QR Code 加入團隊",
EmptyFileCannotBeUploaded: "空檔案無法上傳，請重新選擇",
EnableFingerprintLogin: "是否開通指紋登入",
End: "結束",
EndDate: "結束日期",
EndorseTrain: "我要改簽",
EnglishName: "英文姓名",
EnquiryOrderNumber: "需求單號",
EnterANewPassword: "輸入新密碼",
EnterflightNoMU5166: "請輸入航班號，如 MU5166",
EnteringKefu: "正在連接人工客服",
EnterMembershipNumber: "請輸入會員卡號",
EnterNewMobile: "請輸入新的手機號碼",
EnterPhoneNumber: "請輸入手機號",
Enterprise: "企業",
EnterpriseCertification: "企業認證",
EnterpriseCodeBind: "企業碼綁定",
EnterpriseCodeDescription: "企業碼是一種基於支付寶的企業因公支付能力。",
EnterpriseCodePay: "企業碼支付",
EnterpriseCooperation: "企業合作",
EnterprisePaymentCompleteTicket: "企業支付，完成購票",
EnterTheLastFourDigitsOfYourID: "證件號後4位",
EnterVerificationCode: "請輸入驗證碼",
EnterVerificationCode_1: "輸入驗證碼",
EnterVerificationCodeForThe12306: "請輸入 12306 回覆的驗證碼",
EnterYourNewPasswordAgain: "再次輸入新密碼",
EntryTimes: "入境次數",
EssentialDocuments: "必備材料",
Estimate: "預估",
EstimateMeteredBilling: "預估（打表計費，以實際為準）",
ETA: "預計到店",
Etc: "...等航空公司",
EUR: "歐元",
EvaluateKefu: "請對本次服務做出評價",
ExactlyLate: "正晚點",
ExceedingOrderAmount: "超出滿減限制",
Exchange: "兌換",
Exchange_1: "立即兌換",
ExchangeSerialNumber: "兌換流水號",
ExchangeSuccessful: "兌換成功",
ExcludingFullPriceAverageDiscount: "不含全價平均折扣",
ExclusiveBrandPrivileges: "尊享品牌特供權益",
ExecuteAction: "執行動作",
ExistingBusinessTravelAccount: "已是恒順商旅簽約企業",
ExistingStaff: "已有員工",
Exit: "安全出口",
ExitWarning: "退出將解除微信與此帳號的綁定，解除綁定後將無法接收此帳號的微信訊息通知，確定要退出嗎？",
ExpandMore: "展開更多",
ExpectedTravelDate: "預計出行日期",
ExpectToAt: "預計",
Expired: "已過期",
ExportFormat: "導出格式",
ExportOrder: "下載訂單明細",
Express: "快遞",
ExpressDelivery: "快遞配送",
Ext: "分機號",
ExtendedInformation: "擴展資訊",
Face: "人臉核驗",
FaceGetCameraFailTips: "目前頁面暫時無法開啟攝像頭，您可以先檢查攝像頭權限是否已開啟。若仍無法解決，可點擊複製連結，透過其他瀏覽器開啟嘗試。如已授權攝像頭，請點擊繼續。",
FaceIDIsNotEnabled: "目前設備未啟用面容ID",
FaceIDIsOnlyValidForTheMachine: "面容ID僅針對本機有效",
FaceIDLogin: "面容登入",
FacilitiesDetails: "設施/詳情",
FacilityServices: "設施服務",
FailedToAccessTheCamera: "存取攝像頭失敗",
FailedToChangePassword: "修改密碼失敗",
FailedToGetPleaseTryAgainLater: "獲取失敗，請稍候再試",
FailedToResetPassword: "重置密碼失敗",
FalseAlarmAccountability: "謊報警情，依法追責",
FalseAlarmAccountabilityDesc_1: "一鍵報警會接通平台客服，如遇危害人身及財產安全的緊急情況，請直接撥打110。",
FalseAlarmAccountabilityDesc_2: "謊報警情將可能被處以五日以上十日以下拘留",
FalseReport: "謊報警情將依法承擔法律責任",
Favorites: "收藏夾",
FeaturedIntroduction: "特色介紹",
Feedback: "意見反饋",
Feishu: "飛書",
FeishuByAccount: "飛書帳號",
FeishuByUser: "飛書員工綁定",
File: "文件",
FileDownloadFailed: "文件獲取失敗",
FillInAccordingToTheActualNumber: "按照實際人數填寫",
FillInAccurateAndCompleteUnitInformation: "請填寫準確完整的單位資訊，以便更好地為您服務",
FillingGuide: "填寫指南",
FillInTheReason: "填寫原因",
FillInYourBoundEmailAddress: "填寫您綁定的電子郵件地址",
FillTaxNumberIfAvailable: "如有稅號，請務必填寫",
Filter: "篩選條件",
Filter_1: "進階篩選",
Filters: "篩選",
FindANewQueryQuote: "找到新的查詢報價",
FingerprintDoItAgain: "驗證失敗，再試一次",
FingerprintTouch: "輕觸指紋感測器",
FingerprintVerification: "驗證指紋",
FingerprintVerificationTooManyTimes: "指紋驗證次數過多，請稍後再試",
Finish: "完成",
Finished: "已完成",
FirstBusinessClass: "頭等/商務艙",
FirstClass: "頭等艙",
FirstClassSeat: "一等座",
FirstNameFormatIsIncorrect: "英文名格式不正確！",
FirstStep: "第一步",
FixedPrice: "一口價",
Fld: "代金豆",
FldDetails: "代金豆明細",
FldRules: "代金豆規則",
FldUsageRules: "代金豆使用規則",
Flight: "飛機",
FlightBookPermission: "機票預訂權限",
FlightCancellationDelayForMoreThan: "航班取消／延誤30分鐘以上，以航空公司審核為準",
FlightConfirmationWarn: "用於辦理簽證和出入境審查，可列印確認單並在出行時隨身攜帶",
FlightDate: "航班日期",
FlightDeparturesAreLocalTime: "航班起降均為當地時間",
FlightDetails: "航班詳情",
FlightDynamicsAreForReferenceOnly: "航班動態僅供參考，請以航司發布為準",
FlightInformation: "航班動態",
FlightInformationDesc: "航班變更等行程提醒",
FlightInfoSync: "航班動態資訊將同步給司機，便於準時接送",
FlightNo: "航班號",
FlightNumber: "按航班號",
FlightNumberHotelTrainNumber: "航班號／酒店／車次",
FlightPreference: "航班偏好",
FlightPricesChangeFrequently: "航班價格變動頻繁，請盡快完成支付以免耽誤您的出行",
FlightRank: "機票差標",
FlightRefundOrderConfirm: "機票退票訂單確認",
FlightRefundTips: "溫馨提示：已辦理值機手續的旅客需要先行取消值機，方可操作改期、退票。退票一經提交，座位將立即取消，請務必仔細核對資訊。",
FlightRefundTrip: "退票行程",
FlightRescheduleOrderConfirm: "申請改期訂單確認",
FlightReschedulingOrRefundTips: "溫馨提示：已辦理值機手續的旅客需要先行取消值機，方可操作改期、退票。",
FlightSeatInfoArrow: "選座資訊 >",
FlightsRefunds: "國內機票退票",
FlightTicket: "機票",
FlightTicketInquiry: "機票詢價",
FlightTicketIssuedGetReceiptByEmail: "機票已出票，可透過信箱取得機票報銷憑證",
FlightTicketLatitude: "機票維度",
FlightType: "航班類型",
FloatingOptionalDate: "浮動可選日期",
Floor_1: "樓層",
FollowFromEmployee: "從員工中關注",
FollowTheSystem: "遵循系統",
Foods: "餐品",
FoodTotalPrice: "商品總價",
ForDomesticTicketsPleaseReturnToTheHomePageAndSelectDomesticTickets: "如需查詢國內機票，請返回首頁選擇國內機票",
ForgetPassword: "忘記密碼",
ForgetPassword_1: "忘記密碼?",
FormatIsIncorrect: "格式不正確",
Founder: "建立人",
Free: "快遞 免郵",
FreeBoardband: "免費寬帶",
FreeParking: "免費停車場",
FreePickUpService: "免費接機服務",
FreeWiFi: "免費WiFi",
FrequentContacts: "常用联系人",
FrequentContactsManagement: "常用联系人管理",
FrequentTraveler: "常旅客",
FrequentTravelerCardInformation: "常旅客卡",
FrequentTravelerManagement: "常旅客管理",
FriendsareWaiting: "的小夥伴在恒順商旅等你，用這個專屬連結加入我們吧！",
Fuel: "燃油",
FuelFee: "燃油費",
FullPrice: "全價",
FullyBooked: "已訂完",
FullyCallingTheVehicle: "正在全力呼叫車輛",
FunctionIntro: "功能介紹",
GBP: "英鎊",
Gender: "性別",
GeneralAmenities: "服務設施",
GeneralCarUsage: "用車總概",
GeneralConditionsOfTransportation: "總運輸條件",
GeneralTrainTicket: "火車票總概",
Generated: "已生成",
GenerateTravelReports: "生成差旅報表",
GenerationFailed: "生成失敗",
GenerationSuccessful: "成功生成",
GetDidiJumpUrlFailed: "無法取得滴滴跳轉連結",
GetInTheCar: "上車",
GetSMS: "獲取短信",
GettingBoardingLocation: "正在獲取上车地點",
GiveLXDAfterBookSuccess: "預訂成功後贈送旅行豆",
GivenNames: "名(拼音)",
GivenNamesEg: "如：MEIMEI",
GivenNamesHint: "例如，王大偉應填寫為「DAWEI」",
GoAlipayCorpPay: "前往支付寶因公付",
GoAndReturn: "去/返",
GoApprovals: "去審批",
GoBook: "去預訂",
GoEnquiry: "去询价",
GoFlight: "去程航班",
Going: "去程",
GoingDate: "去程日期",
GoingFilter: "去程筛选",
GoingTo: "將去",
GoLogin: "去登入",
GoToAlipayOpenEnterpriseCode: "去支付寶開通企業碼",
GoToBind: "去綁定",
GoToChange: "去改期",
GoToDidiHome: "滴滴首頁",
GoToDownload: "前往下載",
GoToHotel: "去酒店",
GoToPay: "去支付",
GoToQuery: "前往查詢頁面",
GoToRefund: "去退票",
GoToSettings: "前往設定",
GoToShare: "去分享",
GoToVerify: "去核驗",
GoToView: "去查看",
Greeting: "Hello，很高興見到你！",
Guarantee: "擔保",
Guarantee_1: "需擔保",
GuessYouWantToFindIt: "猜你想問",
Guests: "入住人數",
Gym: "健身房",
Handled: "已辦",
HasProblem: "支付遇到問題",
HasQuitHumanCustomerService: "已退出人工客服",
HaveAgreement: "有協議價",
HaveQuestions: "有疑問?可点击下方按钮进行咨询哦~",
HaveRefund: "有退票",
HaveRescheduled: "有改期",
HelpCenter: "幫助中心",
HengshunTravelAPP: "恒順商旅APP",
HightoLow: "價格 高-低",
History: "歷史記錄",
HistoryOrder: "歷史訂單",
HistoryOrHot: "歷史/熱門",
HistoryOrLocation: "當前/歷史",
HistoryRecord: "歷史記錄(近1年)",
HKD: "港幣",
HoldToSpeak: "按住說話",
HoldToTalk: "按住 說話",
Home: "首页",
HOMSOM: "恒順商旅",
Homsom: "我的恒順",
HomsomEnterpriseCooperation: "恒順商旅企業合作",
HomsomEnterpriseCooperationDesc: "如貴司已是恒順商旅簽約企業，請聯繫您的客戶經理獲取帳號，請勿重複註冊",
HomsomFWXY: "服務協議",
HomsomGuarantee: "恒順擔保",
HomsomLoginPrivacyInfo: "已閱讀並同意《服務協議》和《隱私政策》。",
HomsomLoginPrivacyTitle: "請閱讀並同意以下協議",
HomsomLoginPrivacyValue: "為保障您的個人信息安全，使用登录功能需要您先閱讀並同意《服務協議》和《隱私政策》。",
HomsomLxd: "恒順旅行豆",
HomsomPrivacyInfo: "服務協議》和《隱私政策》",
HOMSOMScanningCodeLoginConfirmation: "恒顺商旅网扫码登录确认",
HomsomServiceFee: "恒順服務費",
HomsomServiceFeeByChange: "恒順改期服務費",
HomsomServiceFeeByIssue: "恒順出票服務費",
HomsomSuccessDesc: "恒順商旅已為您完成本次預訂服務",
HomsomTools: "常用工具",
HomsomUpdateToExperience: "恒順商旅又有更新了，快來抢先體驗吧",
HomsomYSZC: "隱私政策",
Hot: "熱門",
Hot_1: "熱門兑换",
HotChina: "國內熱門",
Hotel: "酒店",
HotelAddress: "酒店地址",
HotelBedNeeds: "床型要求",
HotelBookPermission: "酒店預訂權限",
HotelBookWarn: "請您在提交訂單前仔細閱讀《恒順商旅酒店預訂條款》《個人資訊授權聲明》《供應商預訂條款》",
HotelBookWarn_1: "《恒順商旅酒店預訂條款》《個人資訊授權聲明》《供應商預訂條款》",
HotelChargeback: "酒店退單",
HotelCheckInInfo: "入住信息",
HotelConfirmEmailChineseOrEnglish: "-中/英版確認郵件（中/英版入住證明pdf附件）",
HotelConfirmNumber: "酒店確認號",
HotelConfirmSMSChineseOrEnglish: "-中/英版確認短信",
HotelConsumptionInEachCity: "各城市酒店消費情況",
HotelContactMobile: "聯絡手機",
HotelContactMobilePlaceholder: "用於接收通知",
HotelDetails: "酒店詳情",
HotelDimension: "酒店維度",
HotelEnglishFirstNameHint: "名(例:San)",
HotelEnglishFirstNameRequired: "請填寫名(拼音或英文)",
HotelEnglishLastNameHint: "姓(例:Zhang)",
HotelEnglishLastNameRequired: "請填寫姓(拼音或英文)",
HotelFeature: "酒店特色",
HotelGeneral: "酒店總概",
HotelGroupMembership: "酒店集團",
HotelGroupMembershipCard: "集團會員卡",
HotelGroupMembershipCard_1: "酒店集團會員卡",
HotelGroupMembershipCardBind: "綁定會員",
HotelGroupMembershipCardDetails: "會員卡詳情",
HotelGroupMembershipCardInfo: "酒店集團會員卡信息",
HotelGuestName: "住客姓名",
HotelGuestNameInvalid: "住客姓名格式不正確",
HotelGuestNamePlaceholder: "請填寫住客姓名",
HotelIntroduction: "酒店簡介",
HotelInvoiceExplain: "注：房費发票由酒店开具，请到前台索取",
HotelIsSendRefundEmail: "是否發送退單成功郵件",
HotelIsSendRefundSms: "是否發送退單成功簡訊",
HotelLatestRoomPrice: "已為您獲取最新酒店價格",
HotelMemberCardDesc: "享专属会员积分权益",
HotelMoreGuests: "更多住客",
HotelName: "酒店名稱",
HotelNight: "酒店總間夜",
HotelOtherNeeds: "其他要求",
HotelPayInStore: "到店支付",
HotelPriorityContact: "飯店優先聯絡",
HotelPromptIsMorning: "如需今天早晨6點前入住，請選擇今天凌晨入住",
HotelQuickConvertPinyin: "一鍵轉拼音",
HotelQuickSelectGuest: "選擇住客",
HotelRank: "酒店差標",
HotelRating: "酒店星(鑽)級",
HotelRC: "酒店RC",
HotelReasonCodeDistribution: "酒店ReasonCode分布",
HotelRefundGuestTitle: "取消訂單的入住人",
HotelRefundInformation: "退單資訊",
HotelReservationAuthority: "國內酒店差標",
HotelRestaurant: "酒店餐廳",
HotelRoomNumber: "房間數量",
HotelRoomRemarkInputTip: "如果有其他需求請填寫，酒店會盡量為您安排",
Hotels: "酒店的",
HotelSelectChargebackGuest: "選擇取消的入住人",
HotelService: "酒店服務",
HotelServicePreferences: "服務-喜好",
HotelServicePreferences_1: "服務喜好",
HotelSpecialNeeds: "特殊要求",
HotelSpecialNeedsEditHint: "如果有其他要求請填寫，酒店會盡量為您安排。",
HotelSpecialNeedsExplain: "我們會把您的要求轉達給酒店，但不保證酒店一定可以滿足，如有特殊要求，請自行聯絡酒店。",
HotelTotalAmount: "酒店總金額",
HowSoonWillYouNeedTheCarAfterLanding: "落地後多久用車",
HowToUseTip: "如不確定如何使用",
HsTravelerExplainContext: "您已知曉您在恒順商旅錄入的常旅客身份資訊，將用於您預訂機票、火車票等所有需要實名制的產品，並在使用時進行驗證，請確保此資訊真實有效。恒順商旅將透過加密等方式保護此資訊，且僅在具體交易時授權提供給相關第三方。",
HsTravelerExplainTitle: "閱讀並同意以下內容",
IAm: "我是",
ID: "證件號",
IDCard: "身份證號",
IDCardFormatIsIncorrect: "身份證號碼格式不正確！",
IdNameMatchTip: "與證件姓名一致",
IDNoVerify: "證件號核驗",
IDNumber: "證件號碼",
IDType: "證件類型",
IfTheApproverIsInconsistent: "審批人不一致請分開下單",
IfTheRemainingSeats: "若剩餘席位無法滿足選座需求，系統將自動為您分配席位",
IfTheTicketHasBeenIssuedTheLossMustBeBorneByTheOwner: "2.若已出票，退改損失需自行承擔。",
IfYouCheckThisOption: "如果您勾選了此選項，接下來的行程將視為私人行程",
IfYouHaveAnyQuestions: "如果您有任何疑問，請致電恒順商旅全國服務熱線：4006-123-123",
IfYouHaveAnyQuestionsPleaseContactYourBusinessConsultant: "如有疑問請聯繫您的業務顧問",
IfYouNeedToNarrowTheScopePleaseEnterMoreConditions: "若需縮小範圍，請輸入更多條件。",
IGotIt: "我知道了",
IHaveReadAndAgree: "已閱讀並同意",
ImageAndFileCannotSelectTogether: "圖片和文件不能同時選擇",
Import: "導入",
Import_1: "導入",
ImportBusiness: "導入(因公)",
ImportFailed: "導入失敗",
ImportFromFrequentTraveler: "從員工中導入",
ImportSuccess: "導入成功",
IncludingHongKongMacauAndTaiwan: "含港澳台",
Income: "收入",
IncomeExpenditure: "收支明細",
InconsistentPasswordEnteredTwice: "兩次輸入的密碼不一致",
IncorrectFormatOfContactMobileNumber: "聯絡人手機號格式不正確！",
Indexs: "字母索引",
IndividualOrNonEnterprise: "個人/非企業",
InformationDescription: "信息說明",
InformationIsIncomplete: "基本資訊不全",
InformationVerification: "信息驗證",
Infrastructure: "基礎設施",
Initiated: "已發起",
InitiativeEnthusiasmEfficientMeticulousSpecialty: "更主動 更熱情 更高效 更細緻 更專業",
InnovativeService: "用心創新服務",
InPersonRequired: "本人到場",
InputBookingPassword: "請輸入預訂密碼",
InputBookingPwdTip: "由公司帳戶支付費用，請輸入預訂密碼",
InputConfirmPassword: "請輸入確認密碼",
InputHint: "您可以訴說需求，我將全力滿足哦~",
InputInformation: "輸入信息",
InputQuestionHint: "輸入問題，來問我~",
InquiryInformationIsInvalid: "查詢信息失效",
Install: "立即安裝",
Instructions: "須知",
InsufficientRemainingTicketsChooseOtherFlight: "該艙位餘票不足，請選擇其他艙位",
InsuranceNotice: "投保須知",
Insurers: "保險",
Integral: "積分",
Integral_1: "商品積分",
IntegralByHomsom: "恒順商旅積分",
IntegralMall: "積分兌換",
IntercityCarHailing: "跨城叫車",
IntergralDescription: "積分說明",
IntergralRules: "積分規則",
InternalProcurement: "內采",
International: "海外",
InternationalHotel_1: "海外酒店(不含港澳台地區)",
InternationalHotelOrderConfirmation: "海外酒店訂單確認",
InternationalHotelOrders: "海外酒店訂單",
InternationalRegion: "國際/中國港澳台",
InternationalRegion_1: "國際機票·港澳台",
Internet: "上網",
InTheLocation: "定位中",
InTheTicket: "出票中",
Intl_1: "國際",
IntlDestination: "海外目的地",
IntlFlightEnquiry: "國際機票需求單",
IntlFlightEnquiryService: "國際機票詢價服務",
IntlFlightEnquiryServiceDesc: "人工詢價，省時更省心",
IntlFlightOrder: "國際機票訂單",
IntlFlightRank: "國際機票差標",
IntlFlights: "國際機票",
IntlFlights_1: "國際機票(含港澳台地區)",
IntlFlightsChange: "國際機票改期",
IntlFlightsOrderConfirmation: "國際機票訂單確認",
IntlFlightsRefund: "國際機票退票",
IntlHotel: "海外酒店",
IntlHotelReservationAuthority: "海外酒店差標",
InTrainTransfer: "車內換乘",
InTravel: "出差中",
Invalid: "已失效",
InvitationOtherType: "其他邀請方式",
InvitationStaff: "邀請員工",
Invitee: "邀請人",
InviteEmployeesToJoin: "透過下列任意方式邀請員工加入團隊，管理員審核人員資訊後，員工即可收到簡訊通知。",
Invoice: "發票",
InvoiceAmount: "開票金額",
InvoiceAmount_1: "發票金額",
InvoiceCheckGuide: "您可以前往查看，或前往待開票列表繼續開票",
InvoiceContent: "發票內容",
InvoiceDetais: "發票詳情",
InvoiceFilling: "發票填寫",
InvoiceFinished: "已開票",
InvoiceHeader: "發票抬頭",
InvoiceHeaderName: "抬頭名稱",
InvoiceHeaderType: "抬頭類型",
InvoiceInformation: "開票資訊",
InvoiceInst: "開票說明",
InvoiceIssuingMustRead: "開票必讀",
InvoiceOperating: "開票中",
InvoiceParagraph: "發票稅號",
InvoicePreview: "發票預覽",
InvoiceRemarks: "發票備註",
InvoiceTitleCannotBeAllNumbers: "發票抬頭不能全為數字",
InvoiceTitleCannotEdit: "已保存的發票抬頭暫不支持編輯，您可以刪除後重新添加",
InvoiceTitleFillReminder: "請仔細填寫發票抬頭等信息，如因填寫不正確造成開具和下載失敗或無法報銷，鐵路運輸企業概不承擔責任",
InvoiceTitleManagement: "發票抬頭管理",
InvoiceType: "發票類型",
InvoicingStatus: "開票狀態",
InvoluntaryRefund: "非自願退票",
InvoluntaryRefundDesc: "非自願退票(航班取消/延誤30分鐘以上，以航空公司審核為準)",
InvoluntaryRefundExplain: "非自願退票說明",
InvoluntaryReschedule: "非自願改期",
InvoluntaryRescheduleDesc: "非自願改期(航班取消/延誤30分鐘以上，以航空公司審核為準)",
InvoluntaryRescheduleExplain: "非自願改期說明",
IsLoggedIn: "已登入",
IsSendReceiveEmail: "接單郵件",
IsSendReceiveSms: "接單簡訊",
IssuedAmount: "已開具金額",
IssueElectronicInvoice: "開具電子發票",
IssueInvoice: "開具發票",
Issuing: "開具中",
JobDescription: "差標描述",
JoinedEnterpriseGetResult: "已加入企業，獲取授權結果",
JPY: "日圓",
JuHeYongCheNotIncludeDiDiTravel: "聚合用車不包含滴滴出行",
JumpToDidi: "跳轉滴滴查看",
JustLookAtTheHighSpeedTrain: "只看高鐵動車",
JustTime: "剛剛",
KeyBusinessTripInfo: "根據貴司規定，用車需填寫其他資訊",
KeyMoreCarTypes: "更多車型",
KeyMoreSelectionFaster: "勾選越多，叫車更快",
KeySwipeUpMoreCars: "上滑查看更多車型",
KeyTaxiMeterPricing: "出租車打表計費，以實際為準",
Keywords: "關鍵字",
KeywordSearch: "關鍵字搜索(酒店名)",
KeywordSearch_1: "位置/品牌/酒店名",
KPIAnalysis: "機票KPI分析",
KRW: "韓幣",
LackOfIntegral: "積分不足",
Landing: "落地",
Language: "多語言",
LanguageBeingSet: "正在設定語言...",
LanguageCH: "中文",
LanguageDefault: "預設語言",
LanguageEN: "英文",
LanguageSetting: "語言設置",
LastNameFormatIsIncorrect: "英文姓格式不正確！",
LatestArrivalDate: "最晚到賬日期",
LateToEarly: "起飛時間 晚-早",
Latitude: "多維度分析",
LearnAbout: "溫馨提醒",
LearnMore: "了解超標付費",
LessThan10People: "10人以下",
LetYourFriendsAlsoDownloadHengshunTravelAPP: "讓您的朋友也可以下載恒順商旅APP",
Light: "淺色模式",
LinkYourCellphone: "綁定手機",
List: "列表",
Loading: "加載中",
Loading_1: "正在刷新...",
LoadMoreTransit: "加載更多中轉車次信息",
LocacleHotHotelRecommend: "當地熱門酒店推薦",
LocalTax: "地方稅",
LocalTime: "當地時間",
LocalTimeOfTheDepartureCity: "起飛城市當地時間",
Location: "當前位置",
Location_1: "定位",
Location_2: "位置距離",
LocationFailed: "獲取當前位置失敗",
LocationNotTurnOn: "定位未開啟",
LocationOfTheUnit: "單位所在地",
LocationPermissionClosed: "定位權限已關閉，請前往系統設定開啟權限。",
LocationPermissionNotEnabled: "定位權限未開啟",
LocationPermissionRequest: "定位權限申請",
LocationPermissionRetryMessage: "目前需要使用定位權限，是否再次開啟？",
LocationPermissionSettingsMessage: "定位權限未開啟，請前往系統設定開啟。",
LocationPermissionUsageMessage: "用於取得您的目前位置，並提供定位相關服務。",
LocationPermissionUsageTitle: "定位權限使用說明",
Login: "登入",
Login12306: "登入12306",
Login12306Account: "登入12306帳號",
Login12306AccountDesc_1: "鐵路局規定購票需實名制",
Login12306AccountDesc_2: "使用當前12306帳號購票/退改簽",
Login12306AccountEnjoyExtremeReversionMemberPoints: "登入12306帳號，享極致退改、會員積分",
Login12306FaceToBeCompleted: "需完成人臉核驗",
Login_1: "登錄",
LoginByAccountPassword: "帳號密碼登入",
LoginByVerificationCode: "驗證碼登入",
LoginByVerificationCodeEmail: "郵箱驗證碼登入",
LoginByVerificationCodeSMS: "短信驗證碼登入",
LoginConfirm: "確認登入",
LoginExpired: "登入失效，請重新登入！",
LoginName: "登入帳號",
LoginOut: "退出登入",
LoginSuccessful: "登入成功",
LoginSuccessful12306: "12306登入成功",
LoginTo12306ToImproveTheSuccessRateOfTicketIssuance: "登入12306帳號提高出票成功率",
LogisticsCompany: "物流公司",
Logout: "退出",
LongPressSaveTheQRcode: "長按圖片保存二維碼",
LookAtThePriceExcludingTax: "看不含稅價",
LookCertificate: "查看證明",
LookChargebackOrder: "查看退單",
LooOriginOrder: "查看原單",
Loss: "損失",
LossAnalysis: "損失分析",
LossPercentage: "佔損比",
LowCarbonHomsomPlantingHomsomForestTogether: "低碳恒順, 共植恒順林",
LowestPrice: "價格最低",
LowestPrice_1: "最低價格",
LowestPriceDetails: "最低價格詳情",
LowestTicketPrice: "机票最低价",
LowPriceFlightRecommendation: "低價航班推薦",
LowtoHigh: "價格 低-高",
LowVersionTip: "目前App版本過低，請更新至最新版本",
LuggageStorage: "行李寄存",
LuxuryHotel: "豪華型酒店",
LuxuryHotel_1: "豪華",
Lxd: "旅行豆",
LxdDetails: "旅行豆明細",
LxdReward: "旅行豆奖励",
LxdRewardCompleteTheOrderToObtain: "訂單完成後可獲得",
LxdRules: "旅行豆規則",
LxdUsageRules: "旅行豆使用規則",
MailSent: "郵件已發送",
MainFlight: "主航班",
MainRoomer: "主入住人",
MainRoomerRequired: "主入住人（必選）",
MakeInvoice: "開發票",
MakeSureToClearCache: "確定清除緩存？",
MakeSureToFingerprintLoginClose: "確定關閉指纹登录？",
MakeSureToLeaveYourCurrentAccount: "確定退出當前帳戶?",
Manage: "管理",
Manager: "經辦人",
ManualApproval: "人工審批",
ManualChange: "人工改簽",
ManuallyImport: "手工導單",
ManuallyPassed: "人工通過",
ManualModification: "手动修改",
ManualRefund: "人工退票",
Map: "地圖",
MapNavigation: "地圖導航",
MapPointSelection: "地圖選點",
MapSelection: "圖選",
MapSurroundings: "地圖/周邊",
MarkAllMessagesAsRead: "將全部消息標記為已讀?",
MatchingTheBestDriverForYou: "正在為你匹配最佳司機",
MaximumFaceValue: "最高票面價",
MayBeAt: "可能在",
Meals: "有餐食",
MealsGoods: "用餐",
MealsOrder: "用餐訂單",
MealsOrderConfirm: "用餐訂單確認",
MealsRank: "用餐差標",
MealsRemarks: "用餐備注",
MeetingRoom: "會議室",
MembershipCardNumber: "會員卡號",
MembershipNumber: "會員卡號：",
MergeIssueReimbursableAmount: "合并开具可报销金额",
Message: "消息",
MessageCenter: "消息中心",
MessageFailedToSend: "信息发送失败，请重试",
MessageSendSuccessfully: "信息發送成功",
MethodOne: "方式一",
MethodThree: "方式三",
MethodTwo: "方式二",
MicrophoneIsRequiredForCurrentService: "當前服務需使用麥風，請前往設定开启",
Mileage: "里程數",
MiniProgramDoesNotSupportDiDiPleaseUseHomsomApp: "小程式不支援滴滴叫車，如需使用滴滴叫車，請下載並使用恒順商旅APP。",
Minute: "分鐘",
MissedSavingAnalysis: "未预订最低价损失",
MixedPayment: "超標付費",
MixedPaymentDesc: "超標差部分自付，優質酒店超標付",
MixedPaymentOpen: "貴公司已开通超标付",
MixedPaymentOpenDesc: "自行支付超標部分即可享受更好的房間",
MixedPaymentSelfPayment: "超標部分自付",
MnlyOneMembershipCardCanBeAddedToTheSameHotel: "非常抱歉，同一家酒店只能添加一個會員卡。",
MobileCode: "手機區號",
MobileInvitationCode: "手機邀請碼",
MobileInvitationCodeShare: "您將含二维码的圖片分享到公司社群，您的同事可以直接掃碼申請",
MobileLinked: "手機號已绑定",
MobilePhoneNumberVerification: "手機號核驗",
MobileUnlinked: "手機號未绑定",
ModifiedSuccess: "修改成功",
ModifiedSuccessfully: "修改成功！新的手機號為",
Modify: "修改",
ModifyTheBoundPhone: "修改绑定手机",
Moments: "朋友圈",
MonthApr: "4月",
MonthAug: "8月",
MonthDeb: "2月",
MonthDec: "12月",
MonthJan: "1月",
MonthJul: "7月",
MonthJun: "6月",
Monthly: "月度",
MonthlyExpense: "逐月消費",
MonthlyKPI: "逐月KPI",
MonthlySummary: "月度汇总",
MonthMar: "3月",
MonthMay: "5月",
MonthNov: "11月",
MonthOct: "10月",
MonthOnMonth: "環比",
MonthSep: "9月",
More_1: "更多",
More_2: "查看更多",
More_3: "查看<br/>更多",
MoreCabinsNoResult: "沒有更多舱位了！",
MoreConsultation: "更多咨詢",
MoreDate: "更多日期",
MoreDateB: "更多\n日期",
MoreDiner: "更多用餐人",
MoreFilterCriteria: "更多筛选条件",
MorePassengerFlight: "更多乘機人",
MorePassengerRoomer: "更多入住人",
MorePassengerVehicle: "更多乘車人",
MorePrice: "更多价格",
MoreSorting: "更多排序",
MoreThan100People: "100人以上",
MoreThanThePurchaseLimitCanNotBuy: "超過限購數量，無法購買",
MoreTraveler: "更多旅客",
Morning: "凌晨",
MorningCall: "叫醒服務",
MultipleAccountsHaveBeenBound: "您輸入的手機號碼绑定了多个账号，请您尝试使用其他登录方式",
MultipleChoice: "多選",
MultipleChoiceSuccessRate: "多選提高成功率",
MultiTierReschedulingNotSupported: "不支持多个行程改期",
MustBeAccompaniedByAnAdultOnBoard: "儿童/婴儿需由成人陪同乘机",
MyAdvancePayment: "我的預付款",
MyApplyTravel: "我的出差申請",
MyApprovals: "待我審批",
MyBalance: "我的余额",
MyCollection: "我的收藏",
MyCustomerService: "我的客服",
MyFld: "我的代金豆",
MyInitiations: "我發起的",
MyIntergral: "我的积分",
MyLxd: "我的旅行豆",
MyTrip: "我的行程",
Name: "姓名",
NameFillingInstructions: "姓名填写说明",
Nation: "國家/地區",
NationalityOfThePerson: "入住人國家/地區",
NationalServicePhone: "全國服務熱線",
NavigateToHotel: "去導航酒店",
Near: "邻近",
NearExpiration: "臨近過期",
NearlyOneMonthApply: "近1個月申請單",
NearlyOneMonthOrder: "近1個月訂單",
NearlyOneYear: "近1年",
NearlyOneYearOrder: "近1年訂單",
NetList: "網單",
NetTransactionPrice: "成交淨價",
Network: "網路",
NetworkRequestConnectionFailed: "網路連接失敗",
NetworkRequestFailed: "網路請求失敗",
New: "新增",
New_1: "新 增",
NewCertificate: "添加證件",
NewContactSuccessFailed: "新增聯絡人失敗",
NewContactSuccessFul: "新增聯絡人成功",
NewDepartment: "新增部門",
NewDialogAlready: "當前已經是新對話了，請繼續聊吧",
NewDiner: "新增用餐人",
NewFlightDate: "新航班日期",
NewFrequentTravelCard: "添加常旅卡",
NewFrequentTravelCard_1: "添加航司常旅客卡",
NewHotelGroupMembershipCard: "添加酒店集團會員卡",
NewMobile: "新的手機號",
NewPassenger: "新增乘客",
NewPassengerFlight: "新增乘機人",
NewPassengerVehicle: "新增乘車人",
NewRC: "新增RC",
NewRoomer: "新增入住人",
NewTraveler: "新增出行人",
NewVersion: "使用新版",
NewVersionFound: "發現新版本",
NextStep: "下一步",
NextStep_1: "下 一 步",
NickName: "暱稱",
NoApply: "暫無申請單",
NoApprovalRequired: "無需審批",
NoAvailableApply: "抱歉，暫無篩選到相關申請單",
NoAvailableCabin: "暫無可預訂艙位",
NoAvailableFlight: "暫無可預訂航班",
NoAvailableFlightDesc: "沒有找到符合條件的航班，您可以變更篩選條件試試~",
NoAvailableHotel: "暫無可預訂酒店",
NoAvailableHotelTip: "沒有找到符合條件的酒店，您可以變更篩選條件試試~",
NoAvailableOrder: "抱歉，暫無篩選到相關訂單",
NoAvailableTrain: "暫無可預訂車次",
NoAvailableTrainTip: "沒有找到符合條件的車次，您可以變更篩選條件試試~",
NoAvailableVouchersForUse: "暫無可用抵用券",
NoBindPhoneTip: "您尚未綁定手機號，請前往設定頁面綁定手機",
NoBreakfast: "無早",
NoChangeablePassengers: "無可改簽的乘客",
NoChildUnderDepartmentsAtPresent: "當前部門下暫無子部門",
NoCollection: "暫無收藏",
NoData: "暫無結果",
NoData_1: "暫無數據",
NoDataBySearch: "抱歉，沒有搜尋到",
NoDataContent: "暫無內容",
NoDataTravelStandard: "暫無相關差標資訊",
NoEnterpriseCodePayOrder: "未取得企業碼支付單號",
NoIncludedChangeFeeTag: "(未包含改期費)",
NoItinerary: "暫無行程",
NoMeal: "無餐食",
NoMore: "沒有更多了",
NoMoreCredential: "暫時沒有更多文件了",
NonBookable: "不可訂",
NoNet: "無網路",
NoNewNotice: "沒有新通知",
NoNews: "暫無消息",
NonStaff: "外部人員",
NonStaffDetail: "外部人員詳情",
NonStaffManagement: "外部人員管理",
Noon: "中午",
NoOrder: "暫無訂單",
NoOrderEnquiry: "暫無需求單",
NoPermission: "暫無權限",
NoPermissions: "沒有權限",
NoPermissionToAccess: "沒有訪問權限",
NoPlatformAvailablePleaseContactYourTravelConsultant: "暫無可用平台，請聯繫您的差旅顧問",
NoRecordDevice: "暫無錄音設備",
NoRemainingTickets: "暫無余票, 不可預訂",
NoReschedulingReeIsIncluded: "未包含改期費",
NoReservationOrders: "目前無預訂單",
NoResult: "沒有結果",
NormalSeat: "商務座席",
NoStay: "未入住",
NotAuthorizedForNow: "暫不授權",
NotBook: "不可預訂",
NotBooking_1: "不 可 預 訂",
NotCertificateInfo: "暫無证件信息",
NotCompletedTheIdentityVerificationFor12306: "還沒有進行12306人證核驗？",
NotCompletedTheIdentityVerificationFor12306_1: "您的12306帳號需要核驗，請您進行核驗",
NotCompletedTheVerificationInOrder: "訂單中還有需要人證核實的乘車人",
NotesOnRefundAndChangeOfVisa: "退改签注意事项",
Nothing: "暫無",
Notice: "通知",
NoticeCanceled: "通知取消",
NoTicket: "無票",
NotInitiated: "未发起",
NotNecessaryChoose: "非必选",
NotNecessaryFill: "非必填",
NotNecessaryFillPleaseFillOrChoose: "請填寫或選擇",
NotNeedDepartPassenger: "沒有需要出发的乘客",
NoTravelCard: "暫無常旅卡信息",
NoTravelStandard: "暫無差標",
NotRefundable: "不可退票",
NoTrip: "當前您還沒有任何行程信息",
NotSelectable: "不可選擇",
NotSendEmptyInfo: "不可發空白消息",
NotSet: "未設定",
NotSupportOnlineInvoice: "暫不支持線上開票",
NotUsed: "不使用",
NoVisaProductsAvailable: "暫無簽證產品",
Now: "現在",
Number: "人數",
Number_1: "數量",
NumberOfAdult: "總成員",
NumberOfChild: "總兒童數",
NumberOfCustomItems: "自定義項數",
NumberOfFullPriceTickets: "全價票張數",
NumberOfGuestsPerRoom: "每間房入住成人數",
NumberOfRoom: "間數",
NumberOfRooms: "房間數",
NumberOfRoomsAndOccupancy: "房間數量及入住人數",
NumberOfRoomsAndPeople: "間數人數",
NumberOfRoomsBooked: "預訂房間數",
NumberOfSheets: "張數",
NumberOfTrainTickets: "火車票張數",
NumberOfWorkers: "員工數量",
NumberProtecting: "號碼保護中",
NZD: "紐西蘭元",
OccupySeatOverCountRemindContent: "一天內 3 次申請車票成功後取消訂單（包含無座車票或不符合選鋪需求車票時取消 5 次計為取消 1 次），當日將不能在 12306 繼續購票。",
OffAndBelow: "折及以下",
OfficialOrderNo: "官網訂單號",
OfflineReservation: "線下預訂",
OK: "知道了",
OldAndNewPasswordsMustNotBeTheSame: "新舊密碼不得相同",
OldVersion: "使用舊版",
OneAirlineCanOnlyAddOneFrequentTravelCard: "非常抱歉，同一家航空公司只能添加一張常旅卡。",
OneClickFill: "一鍵填寫",
OneKeyAlarm: "一鍵報警",
OneKeyAlarmTripShare: "一鍵報警後，行程資訊自動分享至緊急聯絡人",
OneWay: "單程",
OnlineChangeNotSupported: "暫不支持線上改簽",
OnlineCheckIn: "線上值機",
OnlineCheckInUnavailable: "暫不支援直接報到，建議您下載航旅縱橫App，確保順利辦理報到手續。",
OnlineCheckInViaUmetrip: "暫不支援線上值機，請前往航旅縱橫App辦理值機手續。",
OnlineFlight: "值機",
OnlineFlight_1: "去值機",
OnlineFlightWarn: "溫馨提示：網路值機服務由航空公司提供，您辦理值機產生的任何問題請直接與航空公司聯繫。",
OnlinePayment: "線上支付",
OnlinePayment_1: "線上付",
OnlineReport: "線上管理報告",
OnlineSeatSelection: "線上選座",
OnlineService: "線上客服",
OnlyAdultTicketBookingsAreSupported: "僅支持成人票預訂",
OnlyDirectFly: "僅看直飛",
OnlyMe: "僅看自己",
OnlySeeSelected: "僅看已選",
OnlySupportsQueriesForDateRangesWithinOneYear: "僅支持查詢跨度在1年內的日期範圍",
Open: "開通",
Open_1: "去開啟",
Open_2: "打開",
OpenEnterpriseCode: "開通企業碼",
OpenEnterpriseCodeStepTip: "依照以下步驟，完成企業碼開通，約需1分鐘：",
OpenHengshunTraveMobilelEditionForBetterExperience: "打開恒順商旅移動版，使用體驗更佳",
OpenSafari: "Safari開啟",
OpenSuccess: "開通成功",
OpenYears: "開業時間",
OperatedBy: "實際承運",
Operating: "處理中",
Operation: "操作",
Operator: "處理人",
Optional: "可選",
OptionalCities: "可選城市",
OptionalDocuments: "可選材料",
OptionalInParentheses: "（可選）",
OptionalInput: "選填",
OptionalInput_1: "(選填)",
OptionalReturnDate: "可選返程日期",
OrCopyLinkToBrowserPay: "或者複製連結至 Safari 或預設瀏覽器開啟支付",
Order: "訂單",
Order_1: "預約",
Order_2: "訂單問題",
OrderCancelFailed: "訂單取消失敗",
OrderCancelled: "訂單已取消",
OrderCompleted: "訂單已完成",
OrderDate: "下單日期",
OrderDateBookTime: "下單時間",
OrderDetails: "訂單詳情",
OrderFilling: "訂單填寫",
OrderInformation: "訂單信息",
OrderInformationForChange: "改期訂單信息",
OrderInformationForRefund: "退票訂單信息",
OrderInformationRefund: "退單訂單信息",
OrderIntergral: "訂單积分",
OrderNo: "訂單編號",
OrderNo_1: "兌換編號",
OrderNoCannotBeEmpty: "訂單號不能為空",
OrderNotice: "訂單通知",
OrderNoticeDesc: "出票狀態、預訂狀態提醒",
OrderNumber: "訂單號",
OrderNumber_1: "編號",
OrderPaid: "訂單已支付",
OrderStatus: "訂單狀態",
OrderStatusHasChangedPleaseReOperate: "訂單狀態發生變化，請重新操作",
OrderSubmissionSuccessFailed: "訂單提交失敗",
OrderSubmissionSuccessful: "訂單提交成功！",
OrderSynTime: "同步時間",
OrderTime: "訂單時間",
OrderType: "訂單類型",
OrganizationalStructure: "組織架構",
OriginalPrice: "原價",
OriginalSchedule: "原訂行程",
OriginFlightOrderNo: "原航班訂單號碼",
OriginFlights: "原航班",
OriginOrderNumber: "原訂單",
OriginTrip: "原行程",
OriginTripOrderNo: "原車次訂單編號",
OrTryOurAppForMoreAccurateAndFasterFaceRecognition: "或嘗試使用我們的 app，人臉識別更准更快",
Other: "其他",
OtherConsult: "其他諮詢",
OtherInfo: "其他信息",
OtherLoginMethods: "其他登入方式",
OtherPolicy: "其他規定",
OtherReasons: "其他原因",
OtherWaysOpenInBrowser: "其他方式：手機瀏覽器開啟支付連結",
OurAgreedAveragePrice: "我司協議均價",
OurCompany: "我司",
OurExclusiveConsultantWillContactYouAsSoonAsPossible: "我们的专属顾问会尽快联系您",
OverseasMultiCity: "多程",
OverseasServicePhone: "境外服務熱線",
Overview: "總概",
OverviewOfTickets: "飛機總概",
PackUp: "收起",
PaidBoardband: "收費寬帶",
PaidParking: "收費停車場",
PaidPickUpService: "收費接機服務",
PaidWiFi: "收費WiFi",
PartialChange: "部分改签",
PartialRefund: "部分退票",
Pass: "通過",
Passenger: "乘客",
PassengerDetails: "乘客詳情",
PassengerFlight: "乘機人",
PassengerFlightDetails: "乘機人詳情",
PassengerFlightName: "乘機人姓名",
PassengerInformation: "乘客信息",
PassengerList12306: "12306 乘客列表",
PassengerName: "乘客姓名",
PassengersWhoNeedToRefund: "需要退票的乘機人",
PassengersWhoNeedToReschedule: "需要改期的乘機人",
PassengersWithoutRefundableTickets: "無可退票的乘客",
PassengerType: "乘客類型",
PassengerVehicle: "乘車人",
PassengerVehicleDetails: "乘車人詳情",
PassengerVehicleForChange: "改签乘车人",
PassengerVehicleForRefund: "退票乘車人",
PassengerVehicleInfo: "乘車人資訊",
PassengerVehicleName: "乘車人姓名",
PassengerVehicleWhoNeedToRefund: "需要退票的乘車人",
PassengerVehicleWhoNeedToReschedule: "需要改签的乘车人",
Password: "密碼",
Password12306: "12306密碼非恆順账号密码",
PasswordCanBeResetViaEmail: "可通过已绑定的邮箱地址重设密码",
PasswordCanBeResetViaPhone: "可通过已绑定的手机号+短信验证码重设密码",
PasswordMustBeNoLessThanEightDigitsInLength: "密碼长度不得小于8位",
PasswordMustBeNoLessThanSixDigitsInLength: "密碼长度不得小于6位",
PasswordRuleDescription: "建議密碼由大小写字母和數字組成，且长度大于8位",
PasswordsMustContainLettersAndNumbers: "密碼必須包含字母和數字",
PasswordUpdateSuccessful: "密碼修改成功",
Pay: "支付",
PayAgain: "重新支付",
PayAtTheStore: "到店付",
PayAtTheStoreAbout: "到店支付 約",
PayBackTips: "訂單尚未支付，返回將放弃支付，您可以在訂單中查看並繼續支付！",
PayInformation: "支付信息",
PayInformationDetails: "支付詳情",
Paying: "正在支付",
PayingEnterpriseLabel: "代付企業",
PayingOrQrExpired: "支付中/二維碼過期",
PaymentCompleted: "已完成支付",
PaymentFailed: "支付失敗",
PaymentOnBehalfShareDesc: "發給他人幫你付款吧~",
PaymentPermission: "支付權限",
PaymentSerialNumber: "支付流水號",
PaymentSuccessful: "支付成功",
PaymentSuccessfulContinueToPayTheNextOrder: "支付成功，繼續支付下一個訂單",
PaymentTime: "支付時間",
PaymentWay: "支付方式",
PayNow: "立即支付",
PayOrder: "支付訂單",
PayResultTimeout: "支付結果確認逾時，請稍後在訂單詳情查看",
PayType: "支付類型",
PayTypeCompanyDesc: "由公司帳戶支付費用",
PayTypeMixedDesc: "超出差旅標準的費用需個人支付",
PayTypePersonalDesc: "個人需支付費用",
PdfDownload: "PDF下載",
PdfPreview: "PDF預覽",
PendForOperating: "待处理",
Pending: "待审批",
Pending_1: "申請已提交(待審批)",
Pending_2: "預訂成功(待審批)",
Pending_3: "申請已提交",
Pending_4: "待審核",
People10: "10-20人",
People20: "20-40人",
People40: "40-100人",
PeoplePerRoom: "每間入住",
PercentageOfPotentialSavings: "潜在节省占比",
PercentageOfRoomNights: "間夜佔比",
PercentageOfSavings: "節省佔比",
PercentageOfSheets: "張數佔比",
PermanentResidence: "長期居住地",
PermissionDisabledTitle: "權限未開啟",
PermissionRetryTitle: "權限申請",
PermissionsRange: "權限範圍",
Person: "個人",
PersonAccount: "個人帳號",
Personal: "因私",
PersonalInformation: "个人信息",
PersonalPayment: "個人支付",
PersonalPermissions: "個人權限",
PersonalReschedule: "因私改期",
PersonalRescheduleTip1: "1. 勾選「因私改期」，不變更原有的【因公出行】訂單，僅將新提交的改期訂單變更為【因私出行】；",
PersonalRescheduleTip2: "2. 所有費用（含航司票價差價、航司改期費用等）需由個人承擔，不會發起任何審批和差標校驗；",
PersonalRescheduleTip3: "3. 改期訂單轉為【因私出行】出票成功後，不可再轉回【因公訂單】。",
PersonalTools: "个人工具",
PersonalTravelInformation: "個人差旅信息",
PersonalTrip: "因私出行",
PersonalTrip_1: "私人出行",
PersonalWallet: "個人錢包",
PersonalWorkbench: "個人客戶",
PersonEntry: "個人入口",
PhoneNumberFormatIsIncorrect: "號碼格式不正確！",
PhoneNumberFormatIsIncorrect_1: "手機號碼格式不正確！",
PhoneNumberOrEmailFormatIsIncorrect: "手機號/郵箱的格式不正確",
Photo: "照片",
PhotoOrFile: "照片/文件",
PickUpCity: "上車城市",
PickUpUseCarTimeTenMinute: "落地後10分鐘",
PickUpUserCarTimeFiftyMinute: "落地後50分鐘",
PickUpUserCarTimeFourtyMinute: "落地後40分鐘(有行李託運推薦)",
PickUpUserCarTimeSixtyMinute: "落地後60分鐘",
PickUpUserCarTimeThirtyMinute: "落地後30分鐘(無行李託運推薦)",
PickUpUserCarTimeTwentyMinute: "落地後20分鐘",
Picture: "圖片",
PlaceOfDeparture: "出發地點",
PlaceOfService: "送達地點",
Plan: "原計劃",
Plane: "機型",
PlaneBookNoticeCopyTips: "已複製鏈接到剪切板，小程序暫不支持預覽，請在瀏覽器打開",
PlaneConstruction: "機建",
PlaneConstructionFee: "機建費",
PlaneConstructionFuel: "機建 / 燃油",
PleaseAddARoomer: "請添加入住人",
PleaseAddContact: "請添加聯絡人",
PleaseCancelRoomSelectTitle: "請選擇要取消的房間",
PleaseCheckInAccordingToTheActualFlight: "請按實際乘坐航班辦理值機。",
PleaseCheckTheBoxToAgreeAfterReadingTheRelevantTermsAndConditions: "請閱讀相關條款後勾選同意",
PleaseCheckUserCancelAgreement: "請勾選使用者註銷協議",
PleaseChoose: "請選擇",
PleaseChooseAPlaceOfArrival: "請選擇送達地點",
PleaseChooseAPlaceOfDeparture: "請選擇出發地點",
PleaseChooseASeat: "請選座",
PleaseChooseCarType: "請選擇車型",
PleaseChooseContacts: "請選擇聯絡人",
PleaseChooseIDType: "請選擇證件類型",
PleaseChoosePayWay: "請選擇支付方式",
PleaseChoosesCabinLevel: "請選擇舱位等級",
PleaseChooseTheAirClub: "請選擇航司俱樂部",
PleaseChooseTheDocumentSignatory: "請選擇證件簽署國",
PleaseChooseTheHotelGroupMembership: "請選擇酒店集團",
PleaseChooseTheReason: "請您選擇原因",
PleaseChooseTheReason_1: "請您選擇原因：",
PleaseChooseTheValidityPeriodOfTheCertificate: "請選擇證件有效期",
PleaseChooseWhenToUseTheCar: "請選擇用車時間",
PleaseChooseYourNationality: "請選擇國家/地區",
PleaseCompleteTheReceiptInformation: "請完善收貨信息",
PleaseCompleteTheVerificationAsSoonAsPossible: "請您盡快完成核驗，以免影響出票",
PleaseCompleteYourGivenNames: "請完善您的英文名",
PleaseCompleteYourNameInformation: "請完善您的姓名信息",
PleaseCompleteYourSegments: "請完善您的行程",
PleaseCompleteYourSurname: "請完善您的英文姓氏",
PleaseConfigureTheExaminerInTheBackground: "請后台配置审批人",
PleaseConfirmIfWeChatPaymentHasBeenCompleted: "請確認微信支付是否已完成",
PleaseConfirmPassengerInfo: "請確認乘車人資訊",
PleaseConfirmTheNewPassword: "請确认新密碼",
PleaseContactTheAccountNumber12306: "請关联 12306账号",
PleaseDoNotRefreshThisPagePromptOperation: "請勿刷新本頁，按手機提示操作",
PleaseEnableLocationPermissionOfCurrentApp: "請开启当前应用的定位权限",
PleaseEnter: "請輸入",
PleaseEnter_1: "請輸入要查找的",
PleaseEnterAccurateAndCompleteUnitInformation: "請填寫準確完整的單位信息",
PleaseEnterAComment: "請輸入備注信息",
PleaseEnterACostCenterName: "請填寫成本中心",
PleaseEnterAddress: "請輸入詳細地址",
PleaseEnterAddress_1: "請輸入地址",
PleaseEnterAlipayAccount: "請輸入支付寶帳號",
PleaseEnterANewPassword: "請輸入新密碼",
PleaseEnterASuggestionOfNoLessThanEightWords: "請輸入不少於8個字的建議",
PleaseEnterAUsername: "請輸入登入帳號",
PleaseEnterAuthorizationCode: "請輸入授權碼",
PleaseEnterBindingCredentialName: "請輸入要绑定的证件号",
PleaseEnterBindingCredentialType: "請選擇要绑定的证件类型",
PleaseEnterBindingMobile: "請輸入要绑定的手机号",
PleaseEnterBindingUserName: "請輸入要绑定的名字",
PleaseEnterCompnayInfo: "請輸入企業名稱",
PleaseEnterContactName: "請輸入聯絡人",
PleaseEnterCorrectEmail: "請輸入正確的電郵",
PleaseEnterCorrectMobile: "請輸入正確的手機號碼",
PleaseEnterDestination: "請輸入終點",
PleaseEnterEheCorrectFormatOfValidityPeriod: "請輸入正確的信用卡有效期格式",
PleaseEnterInformation: "請輸入資訊",
PleaseEnterKey: "請輸入要查找的關鍵字",
PleaseEnterMobileVerification: "請輸入手機驗證碼",
PleaseEnterPhone: "請輸入收貨人手機號碼",
PleaseEnterPhoneNumberOrEmail: "請輸入手機號/邮箱",
PleaseEnterRealName: "請輸入真實姓名",
PleaseEnterRecipient: "請輸入收貨人姓名",
PleaseEnterRegisterInfo: "請輸入註冊信息",
PleaseEnterSMSCode: "請輸入短信驗證碼",
PleaseEnterStartPoint: "請輸入起點",
PleaseEnterTheAccountForRetrievePassword: "請先輸入要找回密碼的帳號",
PleaseEnterTheAccountInformationYouNeedToRetrieveYourLoginPassword: "請輸入你需要找回登入密碼的帳戶信息",
PleaseEnterTheAirport: "請輸入要查找的機場",
PleaseEnterTheArriveAddress: "請輸入下載地點",
PleaseEnterTheBindingEmail: "绑定的邮箱",
PleaseEnterTheBindingPhone: "绑定的手机号",
PleaseEnterTheBindingPhoneNumberEmail: "請輸入绑定的手機號/邮箱",
PleaseEnterTheBindingPhoneNumberEmail_1: "绑定的手机号/邮箱",
PleaseEnterTheCardNumber: "請輸入卡號",
PleaseEnterTheCardNumberOrUsername: "請輸入卡號或用戶名",
PleaseEnterTheCarRank: "請輸入要查找的用車差標",
PleaseEnterTheCity: "請輸入要查找的城市",
PleaseEnterTheCityNameToSearch: "請輸入城市名進行搜索",
PleaseEnterTheCompanyAddress: "請輸入公司地址",
PleaseEnterTheCorrectAccountPassword: "請輸入正確的账号密码",
PleaseEnterTheCorrectCreditCardNumber: "請輸入正確的信用卡號",
PleaseEnterTheCorrectMobilePhoneNumberEmail: "請輸入正確的手機號碼/電郵",
PleaseEnterTheCorrectVerificationCode: "請輸入正確的驗證碼",
PleaseEnterTheCostCenter: "請輸入要查找的成本中心",
PleaseEnterTheCountry: "請輸入要查找的國家/地區",
PleaseEnterTheCurrentPassword: "請輸入當前密碼",
PleaseEnterTheCustomItems: "請輸入要查找的自定义項",
PleaseEnterTheDepartAddress: "請輸入上车地点",
PleaseEnterTheDepartment: "請輸入要查找的部門",
PleaseEnterTheFlightBookPermission: "請输入要查找的机票预订权限",
PleaseEnterTheHomeAddress: "請輸入家庭地址",
PleaseEnterTheHotelBookPermission: "請輸入要查找的酒店預訂權限",
PleaseEnterTheHotelCity: "城市/地標/酒店名",
PleaseEnterTheIntlHotelCity: "城市/酒店名",
PleaseEnterTheLastThreeDigitsOfTheCVVSecurityCode: "請輸入CVV安全碼後三位",
PleaseEnterTheName: "請輸入要查找的姓名",
PleaseEnterTheNameOfThePerson: "請輸入入住人姓名或訂單編號",
PleaseEnterTheNameOfThePerson_1: "入住人姓名或订单号或酒店名称",
PleaseEnterTheNameOfTheRank: "請輸入要查找的差標名稱",
PleaseEnterTheNameOfTheRole: "請輸入要查找的角色名稱",
PleaseEnterTheNewPassword: "為必須8-20位字母和數字",
PleaseEnterTheOldPassword: "請輸入原密碼",
PleaseEnterThePassengerName: "請輸入乘客姓名或訂單編號",
PleaseEnterThePassword: "請輸入登入密碼",
PleaseEnterTheReason: "請輸入原因(非必填)",
PleaseEnterTheSystemRole: "請輸入要查找的系統角色",
PleaseEnterTheTemplate: "請輸入要查找的審批模板名稱",
PleaseEnterTheTrainAccountNewPassword: "6-20位字母和數字",
PleaseEnterTheTrainAccountNewPassword_1: "請輸入不少於六位字符",
PleaseEnterTheTrainBookPermission: "請輸入要查找的火車票預訂權限",
PleaseEnterTheTrainStation: "請輸入要查找的火車站",
PleaseEnterTheTraveler: "請輸入要查找的姓名/郵箱/手機號/員工編號",
PleaseEnterTheTraveler_1: "搜索姓名/郵箱/手機號/員工編號/暱稱",
PleaseEnterTheTraveler_2: "搜索姓名/手機號/證件號",
PleaseEnterTheUnitCodeOrUnitShortName: "請輸入單位編號/簡稱/全稱",
PleaseEnterTheValidityPeriodOfTheCreditCard: "請輸入信用卡有效期",
PleaseEnterYourAccountInformation: "請輸入帳號項目",
PleaseEnterYourChineseNameOrEnglishName: "請填寫中文姓名或英文姓名",
PleaseEnterYourExceedReason: "請填寫超標原因",
PleaseEnterYourNewPasswordAgain: "請再次輸入新密碼",
PleaseEnterYourNewPasswordAgain_1: "請確認密碼",
PleaseFill: "請填寫",
PleaseFillBudget: "請填寫預算",
PleaseFillIn: "請填寫新的手機號碼。",
PleaseFillInAlipayAccount: "請填寫支付寶帳戶",
PleaseFillInCardNumber: "請填寫卡號",
PleaseFillInCostCenterName: "請輸入成本中心",
PleaseFillInDepartmentName: "請輸入部門名稱",
PleaseFillInDiner: "請填寫用餐人姓名",
PleaseFillInFirstName: "請填寫英文名",
PleaseFillInGuestName: "請填寫入住人姓名",
PleaseFillInIDNumber: "請填寫證件號",
PleaseFillInLastName: "請填寫英文姓氏",
PleaseFillInName: "請填寫姓名",
PleaseFillInNewPhoneCurrentPhone: "請填寫新的手機號。目前手機號：",
PleaseFillInOrderNumber: "請填寫訂單編號",
PleaseFillInPassengerName: "請填寫乘客姓名",
PleaseFillInPhoneNumber: "請填寫手機號",
PleaseFillInPhoneOrEmail: "請填寫手機號或郵箱",
PleaseFillInRC: "請輸入RC",
PleaseFillInSendingEmail: "請填寫發送郵件",
PleaseFillInTheContactMobilePhoneNumber: "請填寫聯絡人手機號",
PleaseFillInTheReasonForRefund: "請填寫退票原因",
PleaseFillInTheReasonForRescheduling: "請填寫改期原因",
PleaseFillInTheShippingAddress: "請填寫配送地址",
PleaseFillInVerificationCode: "請填寫驗證碼",
PleaseFillTheReason: "請填寫原因(非必填)",
PleaseFillTotalBudget: "請填寫總預算",
PleaseFirstGoToLinkYourDidiAccount: "請先前往綁定滴滴帳號",
PleaseGetTheVerificationCode: "請先獲取驗證碼",
PleaseHoldDownTheSliderAndDrag: "請按住滑塊，拖動到最右",
PleaseHoldThePhoneVertically: "請垂直緊握手機",
PleaseInputCreditCardNumber: "請輸入信用卡號",
PleaseInputYourDestination: "請輸入您的目的地",
PleaseMakeSureYouHaveEnoughTimeToCheckIn: "1.購票前請先到值機櫃檯確認出票後仍有時間值機。",
pleaseOpenScanOnAlipayScanQRCodeToPay: "請打開手機支付寶的掃一掃，掃描二維碼支付",
pleaseOpenScanOnWeChatScanQRCodeToPay: "請開啟手機微信的「掃一掃」功能，掃描二維碼支付",
PleasePressBackOnceToExit: "請再按一次返回退出",
PleaseReadAndAgreeTo: "請先閱讀並同意《帳戶授權協議》",
PleaseReadAndTickTheAgreementFirst: "請先閱讀並勾選協議",
PleaseReselectYourCheckInDate: "請重新選擇入住日期",
PleaseScreenshotSaveQRCode: "請截圖保存二維碼",
PleaseSelectADepartureDate: "請選擇出發日期",
PleaseSelectADestination: "請選擇目的地",
PleaseSelectAirport: "請選擇機場",
PleaseSelectApprover: "請選擇審批人",
PleaseSelectArea: "請選擇所在地區",
PleaseSelectArrival: "請選擇到達地址",
PleaseSelectArrivalAirport: "請選擇到達機場",
PleaseSelectArrivalCity: "請選擇到達城市",
PleaseSelectArrivalTrainStation: "請選擇到達火車站",
PleaseSelectAtLeastOneCityOverseas: "至少選擇一個國際城市/港澳台",
PleaseSelectAtLeastOneOccupant: "請至少選擇1位入住人",
PleaseSelectBackDate: "請選擇返程日期",
PleaseSelectBusinessTravelScale: "請選擇企業差旅規模(月度)",
PleaseSelectCertificate: "請選擇證明",
PleaseSelectCertificateNo: "請輸入證件號",
PleaseSelectCostCenter: "請選擇成本中心",
PleaseSelectDepartment: "請選擇部門",
PleaseSelectDeparture: "請選擇出發地址",
PleaseSelectDepartureAirport: "請選擇出發機場",
PleaseSelectDepartureTrainStation: "請選擇出發火車站",
PleaseSelectDestination: "請選擇城市",
PleaseSelectDiner: "請選擇用餐人",
PleaseSelectedTheCheckInDate: "請選擇入住日期",
PleaseSelectFlightChangeDate: "請選擇航班改期日期",
PleaseSelectFlightDate: "請選擇航班日期",
PleaseSelectFlightNumber: "請填寫航班號",
PleaseSelectGuest: "請選擇入住人",
PleaseSelectGuestLeastOne: "每間房間必須填寫至少一位入住人",
PleaseSelectHotelArrivalTime: "請選擇到店時間",
PleaseSelectLoginTypeWitchAnytime: "請選擇以下任一入口登入",
PleaseSelectOrder: "請選擇訂單",
PleaseSelectOrFillInMealsRemarks: "請選擇/填寫用餐備註",
PleaseSelectOrFillInPurpose: "請選擇/填寫差旅目的",
PleaseSelectOrFillInTheReasonForCancelReason: "請選擇/填寫取消原因",
PleaseSelectOrFillInTheReasonForExceedingTheStandard: "請選擇/填寫超標原因",
PleaseSelectOrFillInTheReasonForRefundReason: "請選擇/填寫退票原因",
PleaseSelectOrFillInTheReasonForReschedulingReason: "請選擇/填寫改期原因",
PleaseSelectOrFillInTheReasonForViolatingTheTravelRank: "請選擇/填寫違反差旅標準原因",
PleaseSelectOrFillInTheReasonOrPleaseSelectTheMixedPayment: "請選擇/填寫超標原因或選擇超標付費",
PleaseSelectPassenger: "請選擇乘客",
PleaseSelectPassengersFirst: "請先選擇乘客",
PleaseSelectPaymentWay: "選擇支付方式",
PleaseSelectPermanentResidence: "請選擇長期居住地",
PleaseSelectPurpose: "請選擇差旅目的",
PleaseSelectSeats: "請選擇座位",
PleaseSelectTheCardExpirationMonth: "請選擇月份",
PleaseSelectTheCardExpirationYear: "請選擇年份",
PleaseSelectTheCheckOutDate: "請選擇離店日期",
PleaseSelectTheDateOfBirth: "請選擇出生日期",
PleaseSelectTheDepartureCity: "請選擇出發城市",
PleaseSelectTheEndDate: "請選擇結束日期",
PleaseSelectTheFavoriteToDeleteFirst: "請先選擇需要刪除的收藏",
PleaseSelectTheFirstSeat: "請選擇第一程座位",
PleaseSelectTheFollowingMethodsForVerification: "請選擇以下方式進行核驗",
PleaseSelectTheItineraryToBeRescheduled: "請選擇要重新安排的行程",
PleaseSelectTheMixedPayment: "請選擇「超額支付」以繼續預訂",
PleaseSelectThePassengerWhoNeedsToChange: "請選擇需要改簽的乘客",
PleaseSelectThePassengerWhoNeedsToRefund: "請選擇需要退票的乘客",
PleaseSelectThePassengerWhoNeedsToReschedule: "請選擇需要改期的行程",
PleaseSelectTheRoomAndRoomer: "客房選擇和入住人",
PleaseSelectTheSecondSeat: "請選擇第二程座位",
PleaseSelectTheShippingAddress: "請選擇收貨地址",
PleaseSelectTheStationWhereYouWillBePickedUp: "請選擇接您的火車網",
PleaseSelectTheTravelApplication: "請選擇出差申請單",
PleaseSelectTheTypeOfQuestion: "請選擇問題類型",
PleaseSelectTrainStation: "請選擇火車站",
PleaseSelectTraveler: "請選擇出行人",
PleaseSendTheAbovePaymentTo: "煩請將以上款項於",
PleaseSure: "請務必確認",
PleaseUseTheFollowingCreditCard: "溫馨提示：僅支援以下信用卡",
PleaseVerifyThatYouHaveAFaceIDForLogin: "請確認已有面容ID，用於登入",
PleaseVerifyThatYouHaveATouchIDForLogin: "請驗證已有指紋ID，用於登入",
PointYourFaceAtTheFrontCameraOfYourPhone: "請將臉部對準手機前置鏡頭",
PoliciesServices: "政策與服務",
Policy_1: "政策",
PolicyAddress: "保單地址",
PolicyNoColon: "保單號：",
PopularDestinations: "熱門目的地",
PopularFilters: "熱門篩選",
PopularRoutes: "熱門線路",
Pptimization: "最佳方案",
Precautions: "注意事項",
Preferential: "優惠",
Preferential_1: "本單可享",
PremiumHotel: "高檔型酒店",
PremiumHotel_1: "高檔",
Prepay: "預付",
Prepayments: "預付款",
PreQuantifier: "/人",
PressVoice: "按住錄音",
Preview: "預覽",
PreviewNotSupportedAndIsCopy: "暫不支持預覽，已複製到剪貼簿，請在瀏覽器中打開",
Price: "價格",
Price1000_1300: "¥1000-1300",
Price1300_1800: "¥1300-1800",
Price150: "¥150以下",
Price150_300: "¥150-300",
Price300_450: "¥300-450",
Price400: "¥400以下",
Price400_700: "¥400-700",
Price450_600: "¥450-600",
Price600_1000: "¥600-1000",
Price700_1000: "¥700-1000",
Price_1: "參考票價",
Price_2: "星級價格",
PriceCeiling: "價格上限",
PriceDetails: "價格明細",
PriceHighest: "從高到低",
PriceHighToLow: "價格高-低",
PriceHotel: "房價",
PriceLowest: "從低到高",
PriceLowToHigh: "價格低-高",
PriceOver1000: "¥1000以上",
PriceOver1800: "¥1800以上",
PriceRating: "價格/星級",
PriceRating_1: "價格/鑽級",
PriceSingleChoice: "價格(單選)",
Print: "列印",
PriorityHighPrice: "高價優先",
PriorityHighRating: "高星優先",
PriorityLowPrice: "低價優先",
PrivacyNumberProtection: "隱私號碼保護",
PrivacyPolicy: "隱私政策",
ProceedToBind: "前往綁定",
Processing: "未處理",
ProcessingCompleteTime: "處理完成時間",
ProcessingNotes: "辦理須知",
ProcessingProcedure: "辦理流程",
ProcessingTime: "處理時間",
ProcessingTime_1: "辦理時長",
ProduceDesc: "產品描述",
ProduceName: "產品名稱",
Product: "產品",
ProductDesc: "產品說明",
ProductExperience: "產品體驗",
ProductId: "產品ID",
ProductIntroduction: "商品介紹",
ProductOverview: "商品概述",
ProductUseRuleDes: "使用規則",
Progress: "進行中",
PromptDateHotel: "您選擇的是酒店當地日期",
PromptDatePrice: "所選日期為出發地日期，價格變動頻繁，以實際為準",
ProportionOfContractedHotelStarLevelTransactions: "協議酒店星級交易額佔比",
ProportionOfHotelRoomNightsInAgreement: "協議酒店間夜佔比",
ProportionOfNetTransactionPrice: "成交淨價佔比",
ProportionOfRCTimes: "RC 次數佔比",
PullToRefresh: "下拉刷新",
PullUpLoadMore: "上拉載入更多",
Punctuality: "准點率",
PutTheQRCodeIntoTheBox: "將二維碼放入框內，即可自動掃描",
QrCode: "二維碼",
QRCodeHasExpired: "二維碼已失效",
Quantity: "機票張數",
Quarterly: "季度",
QueryConditions: "查詢條件",
QueryNotJurisdiction: "您沒有查詢權限",
QueryQuoteErrors: "查詢報價失敗",
QueryRange: "查詢範圍",
QueryResultOfTheCurrentCity: "當前城市查詢結果",
QueryType: "查詢類型",
QuickSelection: "快捷選擇",
RankInformation: "差標信息",
RankManagement: "差標管理",
RankName: "差標名稱",
Rating: "星(鑽)級",
RatingHighToLow: "星級高-低",
RatingLowToHigh: "星級低-高",
RatingMultipleChoice: "星級(可多選)",
RCContent: "RC內容",
RCManagement: "RC管理",
RCType: "RC類型",
Read: "已讀",
Reapply: "重新申請",
Reason: "原因",
ReasonForNotSelectingTheCheapestFlight: "未選擇最低價航班原因",
ReasonForNotSelectingTheLowestPrice: "未選擇最低價格原因",
ReasonForRejection: "駁回原因",
ReasonForTheRefundTicket: "退票類型",
ReasonForTicketIssueFailure: "出票失敗原因",
ReasonForTravelRankingViolation: "違反差旅標準原因",
ReasonsForBusiness: "出差事由",
ReBook: "再次預訂",
ReceiveMode: "接收方式",
RecentlyVisited: "最近訪問",
RecentSearches: "歷史",
Recharge: "儲值",
RechargeAmount: "儲值金額",
Recommend: "推薦",
Recommend_1: "熱門推薦",
RecommendCabinPrice: "為您推薦相同航班的優選價格：",
Recommended: "智能排序",
RecommendedFlights: "推薦航班",
RecommendedTransferFlights: "中轉航班推薦",
RecommendForYou: "為你推薦",
RecommendReason: "推薦理由",
RedirectFailedTryOtherMethod: "若支付未正常跳轉，請嘗試方式二或方式三",
RedirectToDiDiCarHailing: "跳轉至滴滴叫車",
ReElection: "重選艙位",
RefreshFlight: "刷新航班",
RefreshPageTip_1: "訂單審批狀態發生變化，刷新頁面獲取最新動態",
RefreshPrices: "刷新價格",
RefreshQrCode: "刷新二維碼",
RefreshRetry: "請刷新頁面重試～",
RefreshSucceed: "刷新成功",
Refund: "退票",
Refund_1: "退票",
RefundAmount: "退款金額",
RefundAmountPendingApproval: "退款金額待審核",
RefundApprovalFlow: "退票審批流",
RefundCertificate: "退票證明",
RefundChangeAndBaggageInstructions: "退改簽及行李說明",
RefundDetails: "退款明細",
RefundFailed: "退票失敗",
RefundFee: "退票費",
Refunding: "退票中",
RefundInstructions: "退票規則",
RefundOrChangeExplain: "退改說明",
RefundOrder: "退單",
RefundOrderDate: "退票申請日期",
RefundOrderDetails: "退票詳情",
RefundOrderNumber: "退票訂單號",
RefundOrderReason: "退單原因",
RefundOrderTime: "退票申請時間",
RefundPassenger: "退票乘機人",
RefundPolicy: "退票規定",
RefundRate: "退票率",
RefundReason: "退票原因",
RefundSucceed: "退票成功",
RefundTicket: "我要退票",
RefundTrip: "退票的行程",
Regard: "關注",
RegardEmployees: "我關注的人",
RegardFailed: "關注失敗",
RegardSuccess: "關注成功",
Register: "註冊",
Register_1: "註冊信息",
Register_2: "手機驗證",
Register_3: "等待審核",
RegisterNow: "立即註冊",
RegisterSuccess: "我們將盡快與您聯繫，請保持電話通暢，謝謝！",
ReimbursementVoucher: "報銷憑證",
ReissueInvoice: "換開發票",
Reject: "拒絕",
Rejected: "駁回",
RelationAccount: "綁定帳號",
RelationLogin: "綁定並登錄",
RelationToHOMSOM: "請綁定登錄帳號",
ReleaseImmediateLoad: "鬆開立即加載",
ReleaseImmediateRefresh: "鬆開立即刷新",
ReleaseSendSlideUpCancel: "鬆開發送，上滑取消",
ReleaseToCancel: "鬆手取消~",
ReleaseVoice: "鬆開結束",
Relevance: "相關聯",
Relocate: "重新定位",
RemainingEnterpriseCodePayPrefix: "剩餘企業碼支付時間：",
RemainingSubmitTicketIssuePrefix: "剩餘提交時間：",
Remarks: "備註",
ReminderYouCanImportFrequentTravelerInFrequentTravelerManagement: "溫馨提示：常旅客還可以在常旅客管理中透過匯入人員資訊來進行添加。",
RemovalFailedPleaseTryAgainLater: "移除失敗，請稍後再試",
RemoveFrequentTraveller: "移除該常旅客",
RemoveFromTheTiedList: "從已綁清單中刪除",
RemoveSuccessful: "移除成功",
RemovetheCostCenter: "刪除該成本中心",
RemoveTheDepartment: "刪除該部門",
RemoveTheEmployee: "刪除該員工",
RemoveTheNonEmployee: "刪除該外部人員",
RemoveTheRC: "刪除該RC",
RemoveThisFrequentContact: "刪除該常用聯絡人",
RenovationYears: "裝修時間",
ReportName: "報表名稱",
ReportTotal: "總計",
ReQuery: "重新查詢",
RequiredChoose: "必選",
RequiredChooseArrivalCityAddressDesc: "(必選)出差途經城市皆需添加",
RequiredChoosePleaseChoose: "(必選)請選擇",
RequiredChooseUneditable: "(必選)不可編輯",
RequiredDocuments: "所需材料",
RequiredFill: "必填",
RequiredFillPleaseFill: "(必填)請填寫",
RequiredFillPleaseFillOrChoose: "(必填選)請填寫或選擇",
RequiredFillUneditable: "(必填)不可編輯",
RequiredReadingForBook: "出行須知",
RequiredReadingForChange: "改期須知",
RequiredReadingForHotel: "訂房須知",
RequiredReadingForRefund: "退票須知",
RequiredReadingForTrainChange: "改簽須知",
ReReserveSeat: "重新占座",
ReScan: "重新掃描",
Reschedule: "申請改期",
Rescheduled: "改期",
Rescheduling: "改期行程",
ReschedulingApprovalFlow: "改期審批流",
ReschedulingFee: "航司改期費用",
ReschedulingReason: "改期原因",
ReSearch: "重新搜尋",
Reselect: "重新選擇",
Reselect_1: "重選去程",
ReselectFlight: "重新選擇航班",
ReSelectPrice: "重選價格",
Resend: "重新發送",
ResendConfirmationMessage: "重新發送確認資訊",
ResendPleaseWait: "重新發送請等待",
ResendReimbursementVoucher: "重新發送報銷憑證",
ReservationBeforeDidi: "在前往滴滴平台叫車前，需填寫用車預訂單。若不確定如何使用",
ReservationOrder: "預訂單",
ReserveApproverNameColon: "備選審批人：",
ReserveCar: "預約叫車",
ReserveNow: "立即預約",
ReserveSeat: "占座",
ReserveUseCar: "預約用車",
Reset: "重置",
ResetFilter: "重置篩選",
ResetPassword: "重置密碼",
ResetPwdSuccess: "預訂密碼重置成功，請返回繼續支付",
ResetUsingBoundEmail: "使用已綁定的郵箱重置",
ResetUsingBoundPhoneNumber: "使用已綁定的手機號重置",
Result: "搜尋結果",
RetrieveByEmail: "電子郵件找回",
RetrieveByMobile: "手機號碼找回",
RetrievePassword: "找回密碼",
RetrievePasswordByMobile: "手機號碼找回",
Retry: "重試",
Return: "返程",
ReturnAndChangeInstructions: "退改簽說明",
ReturnColon: "返:",
ReturnDate: "返程日期",
ReturnFilter: "返程篩選",
ReVetting: "重新送審",
RevisedFlightInformation: "變更後的航班資訊：",
ReviseTheDifference: "航司票價差額",
RideInfo: "乘車資訊",
RMBNight: "元/間夜",
RoleDescription: "角色描述",
RoleDetail: "角色詳情",
RoleManagement: "角色管理",
RoleName: "角色名稱",
Room: "客房",
Roomer: "入住人",
RoomerDetails: "入住人詳情",
RoomerName: "入住人姓名",
RoomFees: "房費",
RoomNight: "間夜",
RoomsAndGuests: "房間及住客",
RoomType: "房型",
RoomTypeDetails: "房型詳情",
RoomTypeRemarks: "房型備註",
RoundTrip: "往返",
Route: "航線",
RouteType_1: "單程/往返",
RUB: "盧布",
Rules: "規則",
SafetyAlarmRequired: "安全警報必讀",
SafetyManage: "安全管理",
SafetyReminder: "請系好安全帶，安全出行，下車前請攜帶好隨身物品",
SalesPrice: "銷售價",
SameLevelApprover: "並級審批人",
SameStationTransfer: "同站換乘",
Save: "保存",
Save_2: "保存修改",
Save_3: "節省",
SaveFailed: "保存失败",
SaveFailedFromCode: "二维码保存失败",
SaveInfo: "保存信息",
SaveOrderError: "保存订单错误，请尝试退至航班查询页面重新选择！",
SaveQRCode: "保存二維碼",
SaveSucceed: "保存成功",
SaveSucceedToPhotoLibary: "已保存到相冊",
SavingAnalysisofBookinginAdvance: "提前預訂天數節省分析",
SavingAndMissedSaving: "節省分析",
Savings: "節省金額",
SavingsLosses: "節省與損失",
ScaleLevel_1: "1萬-3萬",
ScaleLevel_2: "3萬-10萬",
ScaleLevel_3: "10萬-30萬",
ScaleLevel_4: "30萬-100萬",
ScaleLevel_5: "100萬以上",
ScanAndLogin: "掃碼登錄",
ScanCodeLogin: "掃描二維碼登錄",
ScannedAccountVerification12306: "您的12306帳號需要核驗，請儘快通過以下鏈接完成核驗，以免影響您的預訂行程。",
ScannedOCchoose: "或去選擇",
ScanQrByAlipay: "請使用支付寶掃碼支付",
ScanQRCodePay: "掃碼支付",
ScanSuccessfully: "掃描成功",
ScanTheQRCode: "掃描二維碼",
Schedule: "時刻表",
ScheduleConflictTip: "行程衝突提示",
ScheduledItinerary: "已訂行程",
ScheduleTip: "提示：具體以列車實際運行情況為準，請及時關注車站廣播",
Search: "查詢",
Search_1: "搜索",
Search_2: "點擊查詢",
Search_3: "查 詢",
SearchCanBeRescheduled: "查詢可改期航班",
SearchFlight: "機票查詢",
SearchForMoreCities: "搜索更多城市",
SearchHistory: "搜索歷史",
SearchHistory_1: "歷史搜索記錄",
SearchHotel: "酒店查詢",
Searching: "正在搜索",
SearchThisArea: "搜索此區域",
SearchTrain: "火車票查詢",
Seat: "席位",
SeatInfo: "選座信息",
SeatNumber: "座位號",
SeatSelectionDepartingTrip: "選座(去程)",
SeatSelectionReturnTrip: "選座(返程)",
SeatSelectionSucceed: "選座成功",
SecondClass: "二等座",
SecondStep: "第二步",
SecurityAlarmDesc: "遇到危險，請及時110報警",
SecurityAssistant: "安全助手",
SecurityCenter: "安全中心",
SecurityCode: "安全碼",
See: "查看低價",
SeeAll: "查看全部",
Select: "已選",
SelectAddressOnMap: "在地圖上選擇地址",
SelectAll: "全選",
SelectApprover: "選擇審批人",
SelectAtLeastOneColumn: "請至少選擇一列字段導出",
SelectCabin: "選擇艙位",
SelectCarPlatform: "選擇用車平台",
SelectCarScene: "選擇用車場景",
SelectCarUsageSceneRequired: "根據貴司規定需選擇用車場景",
SelectCity: "選擇城市",
SelectCityWithAirport: "請選擇有機場的城市",
SelectConfirmationOrder: "選擇確認單",
SelectContact: "選擇聯絡人",
SelectCustomItems: "選擇自定義項",
SelectDate: "選擇日期",
SelectDeparting: "選去程",
SelectDriverContactObject: "請選擇司機聯絡對象",
Selected: "選中",
Selected_1: "已選中",
SelectedAddress: "選擇地點",
SelectedAsGoing: "選為去程",
SelectedFlight_1: "已選航班",
SelectedFlights: "已選擇航班",
SelectedFlightsForYou: "為您精選以下航班",
SelectedPassengers: "已選擇乘機人",
SelectedPassengerVehicle: "已選擇乘車人",
SelectEmployees: "選擇員工",
SelectEnglishSurname: "選擇英文姓氏",
SelectFlight: "選擇航班",
SelectFlightChangeInfo: "選擇改期航班信息",
SelectFlightChangeStep1: "01.選擇改期的乘機人",
SelectFlightChangeStep2: "02.選擇改期的行程",
SelectFlightChangeStep3: "03.選擇改期的日期",
SelectFlightOnline: "選擇值機行程",
SelectFlightRefund: "選擇退票行程",
SelectFlightRefundInfo: "選擇退票航班信息",
SelectFlightRefundStep1: "01.選擇退票的乘機人",
SelectFlightRefundStep2: "02.選擇退票的行程",
SelectFlightRescheduling: "選擇改期行程",
SelectFollowUser: "請選擇要關注的人",
SelectFromTheAlbum: "從相冊中選擇",
SelectInAlipayCashier: "支付寶收銀台內請選擇",
SelectInvoicingType: "選擇發票類型",
Selection: "選座",
SelectionResult: "選座結果",
SelectLanguage: "選擇語言",
SelectOneWay: "選單程",
SelectOrderExportFields: "選擇訂單導出欄位",
SelectPassengers: "選擇乘客",
SelectPolyphone: "選擇多音字",
SelectReimbursementVoucher: "選擇報銷憑證",
SelectReport: "選擇報表",
SelectReturn: "選擇返程",
SelectTheCardExpirationMonth: "選擇月份",
SelectTheCardExpirationYear: "選擇年份",
SelectTheNumberOfRooms: "選擇間數",
SelectThePassenger: "選擇乘機人",
SelectThePassengerVehicle: "選擇乘車人",
SelectTheReasonForTheRefundTicket: "選擇退票類型",
SelectTheRescheduleType: "選擇改期類型",
SelectTheStartingPointAndDestination: "選擇起訖點",
SelectTrain: "選擇車次",
SelectTrainChangeInfo: "選擇改簽資訊",
SelectTrainChangeStep1: "選擇改簽的乘車人",
SelectTrainChangeStep2: "選擇改簽的行程",
SelectTrainRefundInfo: "選擇退票資訊",
SelectTrainRefundStep1: "選擇退票的乘車人",
SelectTrainRefundStep2: "選擇退票的行程",
SelectTrainRescheduling: "選擇改簽行程",
SelectYourCabin: "艙位選擇",
SelectYourSeatDeparting: "去程選擇",
SelectYourSeatReturn: "返程選座",
Self: "本人",
SelfPay: "自付",
SelfServiceChange: "本人車票改簽",
SelfServiceRefund: "本人車票退票",
Send: "發送",
SendATo12306: "發送至12306",
SendCancelOrderEmail: "發送退單成功郵件",
SendCancelOrderSms: "發送退單成功簡訊",
SendDistressMessage: "發送求救簡訊",
SendEmail: "發送郵箱",
SendEmailOrPhone: "發送至手機/郵箱",
SendFailure: "發送失敗",
SendingLXD: "送旅行豆",
SendMail: "發送郵件",
SendMailSuccessfullyPleaseCheckTheMailboxToResetThePassword: "發送郵件成功，請檢查郵箱重新設置密碼",
SendMoneyToTheFollowingAccount: "匯款至以下帳戶",
SendSMS: "我們已經向",
SendSMS_1: "發送了一條驗證簡訊，請輸入您收到的驗證碼。",
SendSMS_2: "發送簡訊",
SendSMSNotification: "發送簡訊通知",
SendSucceed: "發送成功",
SendToEmail: "發送至郵箱",
SendVerificationCode: "發送驗證碼",
SendVerificationCode12306: "發送簡訊666至12306",
SeniorApprover: "直屬主管",
SerialNumber: "流水號",
Service: "客服",
Service_1: "轉人工",
ServiceAgreement: "服務協議",
ServiceFee: "服務費",
ServiceLife: "使用有效期",
SetAsDefaultContact: "設為默认联系人",
SetAsStaff: "設為員工",
SetBookingPwd: "設定預訂密碼",
SetCompanyAddress: "設定公司地址",
SetEmergencyContact: "設定緊急聯絡人",
SetHomeAddress: "設定家的地址",
SetNewPassword: "設定新密碼",
SetNewPhoneNumber: "设置新手机号",
SetPwdSuccess: "預訂密碼設定成功，請返回繼續支付",
SetPwdTipBeforeCorpPay: "依貴公司規定，使用公司支付前，請先設定預訂密碼",
SetSuccessfully: "設定成功",
Setting: "設定",
SettlementMethod: "結算方式",
SettlementPeriod: "結算帳期",
SettleNow: "現結",
SGD: "新加坡元",
SharedFlight: "共享航班",
SharePDF: "分享PDF",
ShareWithFriends: "分享給好友",
ShippingAddress: "收貨地址",
ShowAvailableTicketsOnly: "只看有票",
ShowMoreSuppliers: "查看更多服务商",
ShowTheFrontOfYourFace: "請展示臉部正面",
SigningPolicy: "簽轉規定",
SignOut: "退出当前账户",
SignOut_1: "退 出 當 前 账 户",
SignResultTimeout: "簽約結果確認逾時，請手動取得授權結果或重試",
SignSuccess: "簽約成功",
Skip: "跳過",
SkipLogin: "不登录，直接预订",
SliderDrag: "向右滑動填滿拼圖",
SlideUpToSeeMore: "上滑查看更多",
SlideYourFingerUp: "手指上滑，取消發送",
Smoke: "吸煙",
SMS: "短信核驗",
SMSVerification: "短信驗證",
SnatchCodeWarn_1: "選擇車次越多，搶票成功率越高",
SnatchCodeWarn_2: "先收取最高票價，出票後差價自動退還",
SnatchInfo: "搶票信息",
SnatchSeatsWarn_1: "-多選座席，抢票成功率更高",
SnatchSeatsWarn_2: "-选择后暂收取最高票价，抢票成功后按实际车票价格退还差价",
SnatchTicket: "搶票",
SnaTchTicketDetails: "搶票詳情",
SoldOut: "已售罄",
SorryCantFind: "对不起，找不到",
SorryNoCabinAvailable: "很抱歉，暫無舱位",
SorryNoFilterFlight: "抱歉，暫無筛选到相关航班",
SorryNoFilterTrain: "抱歉，暫無筛选到相关车次",
SorryNoMatchingFlight: "抱歉，無符合要求的航班！",
SorryNoMatchingHotel: "抱歉，無符合要求的酒店！",
SorryNoMatchingRoom: "抱歉，無符合要求的房型！",
SorryNoMatchingTrain: "抱歉，無符合要求的車次！",
SorryNoSearchFlight: "抱歉，暫無預定航班",
SorryNoSearchTrain: "抱歉，暫无可预定车次",
SorryThePageYouVisitedDoesNotExist: "非常抱歉，您訪問的頁面不存在。",
Sort: "排序",
SortDepartureEarlyToLate: "出发早到晚",
SortDepartureLateToEarly: "出发晚到早",
SortPrice: "價格排序",
SortPriceHighToLow: "價格高到低",
SortPriceLowToHigh: "價格低到高",
SortRecommend: "智能推荐",
SortTime: "時間排序",
SpecialLineForTravelConsultants: "差旅顧問專線",
SpecialOffer: "特價",
SpecificRequirements: "特殊需求",
Spending: "支出",
Staff: "員工",
StaffAdd: "新增員工",
StaffNo: "員工編號",
StarComfort: "三星(鑽)",
StarComfort_1: "三鑽",
StarEconomic: "二星(鑽)及以下",
StarEconomic_1: "二鑽及以下",
StarLuxury: "五星(鑽)",
StarLuxury_1: "五鑽",
StarPremium: "四星(鑽)",
StarPremium_1: "四鑽",
StarRating: "星級",
Start: "開始",
StartDate: "開始日期",
StartVerification: "開始核驗",
StationDropOff: "送站",
StationName: "名稱",
StationPickup: "接站",
StationTransferService: "接送站服務",
StatisticalBillNumber: "統計帳單編號",
StatisticalDate: "統計日期",
StatisticalDimension: "統計維度",
StatisticalMethod: "統計範圍",
StatisticsByUnit: "按單位統計",
Status: "狀態",
Stay: "停留",
StayDuration: "停留時長",
Stayed: "曾到過",
StepOneCopyShareCodeOpenAlipay: "1.複製吱吱碼，打開支付寶",
StepOneOpenAlipay: "1.打開支付寶",
StepOneOpenAlipayScan: "1.打開支付寶，掃一掃",
StepTwoClickAgreeAndUse: "2.點擊同意協議並使用",
StillLeave: "仍要離開",
Stop: "經停",
StopInfo: "經停信息",
StowMoreSuppliers: "收起更多供应商",
SubmissionDate: "提交日期",
SubmissionTime: "提交時間",
Submit: "提交",
Submit_2: "提 交",
SubmitAndJumpDidi: "提交並跳轉至滴滴叫車",
SubmitAndPay: "提交並支付",
SubmitOrder: "提交訂單",
SubmitOrderForChange: "提交改期訂單",
SubmitOrderForChange_1: "提交改签订单",
SubmitOrderPaymentDescription: "提交訂單後透過支付寶企業支付完成購票",
SubmitSucceed: "提交成功",
Submitted: "已提交",
SubmittedMaterials: "已提交的材料",
SubmittedOn: "提交於",
SubmittedRefund: "提交退票",
SubmitTicketIssue: "提交出票",
SubmitVetting: "提交審批",
Subsidiary: "积分明细",
SubwayStation: "地铁站",
SuccessfulPasswordModification: "修改密碼成功",
SuggestMultipleChoices: "建議多選",
SuggestUpdateOrClearFilter: "建議修改筛选或清空条件试试",
SuperEconomyClass: "超級經濟艙",
SuperiorCostCenter: "上級成本中心",
SuperiorDepartment: "上级部门",
SupportImageAndPdfOnly: "僅支持圖片和pdf文件",
SupportingMixedPayment: "支持超標付費",
Surname: "姓(拼音)",
SurnameEgLI: "如：HAN",
SurnameHint: "例如，王大偉應填寫為「WANG」",
Surplus: "剩余",
SwimmingPool: "游泳池",
SwipeVerification: "滑動驗證",
Switch: "轉換",
SwitchAccount: "切換帳號",
SwitchAccountGo: "轉換帳戶可以直接訪問",
SwitchAndAccess: "轉換並訪問",
SwitchPerson: "切换个人",
SwitchPersonAccount: "切换个人账号",
SwitchUnit: "轉換單位",
SwitchUnitAccount: "切换单位账号",
SyncDate: "同步日期",
SystemApproval: "系統審批",
SystemBusy: "系統繁忙，請稍後再試~",
SystemPermissionCamera: "您沒有相机授權，請在設定中打开授權",
SystemPermissionDevice: "您沒有授權讀寫設備，請在設定中打開授權",
SystemPermissionInstall: "安裝此應用需要手动授权，请去设置中开启权限",
SystemPermissionLocation: "您沒有授權定位，請在設定中打開授權",
SystemRecommendedPrice: "系統推薦價格",
SystemRole: "系統角色",
TakeAPicture: "拍照",
TakeOffTimeAnalysis: "起飛時間段分析",
TakesOff: "起飛",
TalkAboutYourSuggestionOrProblem: "說說你的建議或遇到的問題",
Taxi: "打車",
TaxIdOnlyEnglishOrNumbers: "稅號只能是英文或數字",
TaxpayerIDNumber: "納稅人識別號",
TaxRegisterAddress: "稅務登記地址",
TeamLink: "團隊連結",
TeamQRcode: "團隊二維碼",
Telephone: "電話",
TemplateApprovalByDesignatedApprover: "審批流程將根據預訂時選擇的指定審批人來確定。",
TemplateBound: "已綁定其他模板",
TemplateName: "模板名稱",
TemplateNotes: "模板備註",
ThankYouForYourFeedback: "感謝您的反饋",
THB: "泰銖",
TheApplicationFormYouHaveSelectedNotSupportRoundTripSwitching: "您選擇的申請單不支援往返切換",
TheCarryingRegulationsFor: "攜帶鋰電池和行動電源的乘機規定",
TheCityHasBeenSelected: "已選擇該城市",
TheCodeValueIsEmpty: "Code值為空",
TheCurDatCanExcTheNexTriDatPleGoBacToTheHomPagToModify: "當前日期不能超過下一行程日期，請返回首頁修改",
TheCurrentDeviceIsLockedOrNotBiometricEnabled: "當前設備被鎖定或未啟用生物識別功能",
TheCurrentDeviceSupportsFaceID: "當前設備支援面容登入，是否開通？",
TheCurrentDeviceSupportsTouchID: "當前設備支援指紋登入，是否開通？",
TheCurrentLogin: "當前登入為",
TheCurrentNetworkIsNotAvailable: "當前網路不可用",
TheCurrentNetworkIsNotAvailable_1: "當前網路不可用，請檢查連接狀態",
TheCurrentOrderHasBeenSplitIntoMultipleOrdersPleaseGoToTheOrderListToView: "當前訂單已拆分為多張訂單，請前往訂單列表查看",
TheCurrentOrderIsAPersonalPaymentOrder: "當前訂單為個人支付訂單，審批通過後請盡快支付進行出票",
TheCurrentOrderRequiresPersonalPayment1: "當前訂單需個人支付，支付完成後方可出票。",
TheCurrentOrderRequiresPersonalPayment2: "當前訂單需個人支付，支付完成後方可確認。",
TheCurrentPointsAreNotEnoughToExchangeThisItem: "當前積分不足以兌換此商品",
TheCurrentServiceNeedsToUseLocation: "當前服務需使用定位功能，請前往設定開啟",
TheCurrentTimeIsNotAvailableForAppointments: "當前時間不在可預約的範圍內",
TheDriverIsGoingToTheDestination: "司機正在前往目的地",
TheDriverWillContactThePassenger: "司機將與該乘車人聯繫",
TheEmailNotificationHasBeenTurnedOn: "已開啟郵件通知功能, 郵箱地址不能為空！",
TheFlightCombinationYouSelectedCannotBeReserved: "您選擇的航班組合不可預訂，請分開下單",
TheFlightHasInsufficientTickets: "該航班餘票不足, 請選擇其他航班",
TheFollowingTimesAreLocalTime: "以下時間均為當地時間",
TheHotelPicturesAreForReferenceOnly: "*酒店圖片僅供參考，以實際入住為準*",
TheItineraryYouSelectedNotMatchTheApplicationForm: "您選擇的行程與申請單行程不匹配",
TheLengthOfTheViolationOfTheTravelRankCannotExceedXWords: "違反差旅標準原因長度不可超過50個字",
TheLoadingFailedTryAgain: "加載失敗，請重試",
TheLowestLogicalFareIsSuggestedAccordingToTheTravelPolicyOfYourCompany: "根據貴司規定，推薦您預訂最低價航班",
TheLowestPriceForDomesticAirTicketIsNotSelected: "國內機票未選擇最低價，需要選擇的原因",
Theme: "特色",
TheNetworkSignalIsPoor: "網路不給力, 請稍後再試試吧~",
TheNewPassword: "新密碼",
TheNewVersionIsOnlinePleaseUpdateToTheLatestVersion: "新版本已上線，請更新至最新版本。",
TheNumberOfTheTicket: "取票號",
TheOrderConfirmedAndProofOfSuccessfulBookingFollowingMethods: "訂單已確認，可通過以下方式獲得預訂成功證明。",
TheOrderIncludesAirfare: "點擊下一步，表示已閱並同意關於",
TheOrderIncludesRescheduledPassengers: "該訂單中有乘客已改期",
TheOrderIsForIndividualPaymentOrders: "該訂單為個人支付訂單, 改期業務請聯繫您的差旅顧問或致電：4006-123-123",
TheOrderIssuedAndProofOfSuccessfulBookingFollowingMethods: "訂單已出票，可通過以下方式獲取機票確認單。",
TheOrderIssuedAndProofOfSuccessfulBookingFollowingMethodsForTrain: "訂單已出票，可通過以下方式獲取火車票確認單。",
ThePeriodOfValidity: "有效期",
ThePeriodOfValidityTips: "例：2025年6月，請輸入0625",
ThePhoneNumberIsTheSameAsTheCurrentlyBoundMobilePhoneNumber: "該手機號與目前綁定的手機號相同",
TheRailwayBureauStipulatesThatTicketsMustBeSoldByRealName: "鐵路局規定購票必須實名制",
ThereAreOtherFlightsAtTheSameTime: "同時段已有其他航班, 是否繼續?",
TheReasonForExceedingTheStandardCannotExceedXWords: "超標原因長度不可超過50個字",
TheRefundFeeIsBeingApprovalByTheFlightCompany: "退票費航司審核中",
TheRefundFeeIsSubjectToTheReviewOfTheAirlineCompany: "退票費具體以航司審核為准",
ThereMustBeNoContactWithTheSamePhoneNumber: "不得存在聯繫手機號相同的聯繫人",
ThereNoAvailableRoomTypesForBooking: "暫無可預訂房型",
ThereNoAvailableRoomTypesForBookingForChangeFilter: "沒有找到符合條件的房型，您可以更改篩選項試試~",
TheRescheduleType: "改期類型",
TheReschedulingFeeIsBeingApprovalByTheFlightCompany: "改期費航司審核中",
TheReschedulingFeeIsSubjectToTheReviewOfTheAirline: "改期費具體以航司審核為准",
TheRoomerIDNumberCannotBeRepeated: "入住人證件號碼不能重複",
TheRoomIsReservedAllNight: "房間整晚保留, 14:00前到店可能需要等房",
TheSpecificPriceIsSubjectToTheReview: "*具體價格以12306審核為准",
TheSpecificRefundAndChangeRulesShallBeSubjectToTheDateOfTheTicketIssue: "具體退改簽規則以航司審核為准！",
TheSubmissionFailedPleaseTryAgainLater: "提交失敗, 請稍候再試！",
TheSysteIsBusyPleaseReOperate: "系統繁忙, 請重新操作！",
TheSystemIsBusyPleaseTryAgainLater: "系統繁忙，請稍後再試！",
TheTakeoffAndLandingLocalTime: "航班起降時間均為當地時間",
TheTicketYouChooseIsVeryCloseToTheDepartureTime: "您選擇的列車距開車時間很近了，請確保有足夠的時間辦理安全檢查、實名制驗證及檢票等手續，因臨近出發，會有出票失敗風險，請您留意確認信息，以免耽誤您的行程。",
TheTicketYouChooseIsVeryCloseToTheDepartureTimeChange: "您選擇的列車距開車時間很近了，請確保有足夠的時間辦理安全檢查、實名制驗證及檢票等手續，因臨近出發，會有改簽失敗風險，請您留意確認信息，以免耽誤您的行程。",
TheTotalBudgetAmountHasChanged: "總預算金額發生變化",
TheValidityPeriodHasExpired: "有效期已過期！",
TheValidityPeriodHasExpiredByReplace: "您的證件已經過期，請更換其他證件或延期後重新預訂",
ThinkAgain: "再想想",
ThinkCompleted: "已完成思考",
Thinking: "正在思考中",
ThirdPartyBinding: "第三方帳號關聯",
ThirdPartyRelation: "帳號關聯",
ThirdStep: "第三步",
ThisInformationIsForReferenceOnlyIfThereIsAnyChangePleaseReferToTheStationAnnouncement: "*該信息僅作為參考，如有變化，請以車站公告為準",
TicketAmount: "出票金額",
TicketBarrier: "檢票口",
TicketBarrierWaitingPlace: "檢票口/候車地點",
TicketBookingAuthority: "國內機票差標",
TicketChangeRefund: "退改簽情況",
TicketContent: "票據內容",
TicketFare: "票價",
TicketingMail: "出票郵件",
TicketingSMS: "出票簡訊",
TicketingSucceed: "出票成功",
TicketNumber: "票號",
TicketPricesHaveChanged: "機票價格發生變更",
TicketRestrictions: "退改簽",
TicketRestrictionsArrow: "退改簽 >",
TicketRestrictionsCancellationBaggage: "退改簽 行李",
TicketRestrictionsCancellationBaggageArrow: "退改簽 行李 >",
TicketRestrictionsRule: "退改簽規則",
Tickets_1: "/張",
TigerRobot: "小虎機器人",
Time: "兌換時間",
Time_1: "時間",
TimeConsuming: "耗時",
TimeConsumingLeast: "耗時由少至多",
TimeConsumingMost: "耗時由多至少",
TimeDeparture: "發車",
TimeHighToLow: "時間 晚-早",
TimeLowToHigh: "時間 早-晚",
TimeRange: "時間範圍",
Tips: "提示",
Tips_1: "[提示]",
Tips_2: "溫馨提示",
TipsColon: "溫馨提示：",
TMS: "恒順酒店TMS",
TMSOnline: "恒順酒店TMS線上",
ToApply: "去申請",
ToBeConfirmed: "待確認",
ToBeIssued: "待開票",
ToBetterYourBusinessTripExperience: "為了讓您的出差享受更優質的酒店",
ToChoose: "去選擇",
Today: "今天",
ToDo: "待辦",
ToEnsureThatThePassengerInformationIsCorrect: "為保證乘車人信息正確, 請按提示進行核驗",
ToEnsureTheSecurityOfTheAccount: "為保障帳戶安全，請確認是本人操作",
ToGuarantee: "去擔保",
ToGuaranteeAmount: "擔保金額",
ToModify: "去修改",
Tomorrow: "明天",
Tomorrow_1: "後一天",
Top5Cities: "前五城市",
Top5CostCenterExpense: "前五成本中心消費情況",
Top5DeptsExpenses: "前五部门消费分析",
Top5DestinationsbyExpense: "前五目的地消費情況",
TopFiveModels: "前五车型消费分析",
ToSetUp: "去設定",
Total: "合計",
Total_1: "往返總價：",
Total_3: "往返總價",
TotalAmount: "總金額",
TotalAmount_1: "總消費金額",
TotalAmountOfCarUsed: "用車總金額",
TotalAmountOfTrainTicket: "火車票總金額",
TotalAmountPendingApproval: "總金額待審",
TotalBudget: "總預算",
TotalBudgetAmount: "預算總金額",
TotalBudgetRMB: "總預算(元)",
TotalDuration: "總時長",
TotalMileage: "總里程",
TotalMissedSaving: "整體損失",
TotalNumberOfPeople: "總人數",
TotalOrderAmount: "訂單總金額",
TotalPrice: "總價",
TotalPriceIncludingTax: "包含稅/費",
TotalPriceIncludingTax_1: "含稅/費總價",
TotalPriceNoTax: "不含稅價",
TotalPriceNoTax_1: "往返總價(不含稅)",
TotalPriceNoTax_2: "多程總價(不含稅)",
TotalPriceTax: "含稅價",
TotalPriceTax_1: "往返總價(含稅)",
TotalPriceTax_2: "多程總價(含稅)",
TotalSaving: "整體節省",
ToTravel: "待出行",
TouchIDIsNotEnabled: "當前設備沒有开通指纹ID",
TouchIDIsOnlyValidForTheMachine: "指纹ID仅针对本机有效",
TouchIDLogin: "指纹登录",
TourismConference: "旅遊",
Traffic: "周邊交通",
Train: "火車",
TrainAccount: "12306 帳號",
TrainAccountIdVerify: "12306 人證核驗",
TrainAccountIdVerifySuccess: "您的人證信息核驗成功",
TrainAccountLogin12306: "登錄 12036",
TrainAccountName: "帳戶名",
TrainAccountPwd: "帳戶密碼",
TrainAccountPwd12306: "12306账号密码",
TrainAccountSubmitCheck: "提交核驗",
TrainApplication: "火車票申請",
TrainBookPermission: "火車票預訂權限",
TrainChanged: "車次信息可能有變，請重新查詢",
TrainDetails: "車次詳情",
TrainNumber: "車次",
TrainOrders: "火車票訂單",
TrainPickupDropoff: "接送火車",
TrainPreferQuietCoach: "請優選為我分配 「靜音車廂 」席位",
TrainQuietCoachKey: "「靜音車廂」",
TrainRank: "火車票差標",
TrainSeatHoldingDefaultDesc: "正在核對12306登入狀態和鎖定訂單資訊，預估需要1-3分鐘告知結果，請稍等片刻",
TrainSnatchCode: "备选车次",
TrainSnatchDate: "备选日期",
TrainSnatchDeadline: "截止時間",
TrainSnatchSeats: "备选座席",
TrainStation: "火車站",
TrainTicket: "火車票",
TrainTicketChange: "火车票改签",
TrainTicketConfirmation: "火車票訂單確認",
TrainTicketFare: "火車票票價",
TrainTicketLatitude: "火車票緯度",
TrainTicketRefund: "火車票退票",
TrainTicketsYouSearchedFor: "你搜索過的火車票",
TrainType: "車次類型",
Transfer: "中轉",
TransferToAnotherStation: "異站換乘",
TransportationAccommodation: "交通住宿",
TravelApplication: "出差申請單",
TravelApplicationCode: "出差申請單號",
TravelBooking: "差旅預訂",
TravelCard: "常旅卡",
TravelControl: "差旅管控",
TravelDataAnalysis: "差旅数据分析",
TravelDate: "出行日期",
Traveler: "出行人",
Traveler_1: "出差人員",
TravelerDetails: "出行人詳情",
TravelerName: "旅客姓名",
TravelerNameDesc: "請確保與证件上的姓名保持一致",
TravelerType: "旅客類型",
TravelPolicy: "差旅標準",
TravelPositioning: "差旅定位",
TravelPurpose: "差旅目的",
TravelReminder: "出行提醒",
TravelReminderColon: "出行提醒：",
TravelReport: "差旅報表",
TravelSecurity: "出行保障",
TravelStandard: "差標",
TravelStandard_1: "我的差旅",
TravelTime: "出行時間",
TravelType: "差旅類型",
Trip: "行程",
TripAssistantDesc: "行程助手可依據申請單規劃行程",
TripIncludeLegalHoliday: "行程中包含法定節假日",
TripType: "行程類型",
TryAgain: "再試一次",
TryAgain_1: "再 試 一 次",
TryAIFillApplication: "試試讓AI協助填寫出差申請",
TWD: "台幣",
TwinBed: "雙床",
Type: "類型",
Type_1: "原因類型",
TypeOfQuestionRequired: "問題類型(必填)",
TypeOfTrip: "旅行類型",
UnableToBookTheCurrentAgreementPriceProduct: "很抱歉，您的訂單中的乘機人不在航司白名單，因此無法預訂當前協議價產品。",
UnableToLocateCurrentCity: "無法定位當前城市",
UnbindSuccessfully: "解綁成功",
UnbindTitle: "解除綁定",
Unbound: "未綁定",
UnboundApprover: "未綁定指定審批人",
UnboundCustomization: "未綁定自定義項",
UnboundEmployees: "未綁定員工",
UnboundTemplate: "未綁定模板",
UnderOneYearOld: "1歲以下",
UnderTheCurrentCostCenterNoCostCenter: "當前成本中心下暫無子成本中心",
Uneditable: "不可編輯",
Unfilled: "未填寫",
Unfinished: "未結束",
Unfold: "展開",
UnhookYourFingersAndCancelSend: "鬆開手指，取消發送",
UnissuedTicketAmount: "未出票金額",
Unit: "單位",
UnitAbbreviation: "單位簡稱",
UnitAccount: "單位帳號",
UnitEntry: "單位入口",
UnitLogo: "單位logo",
UnitManagement: "單位管理",
UnitName: "單位名稱",
UnitNumber: "單位編號",
UnitNumberOrUnitName: "單位編號或單位簡稱",
Unknown: "未知",
Unmodifiable: "不可修改",
Unselected: "未選擇",
UnStaffAdd: "新增外部人員",
Unsubmitted: "未提交",
Untie: "解綁",
Update: "立即更新",
Update_1: "去更新",
UpdateSearchWhenPullingMap: "拉動地圖時更新搜尋",
Upgrading: "升級中",
UploadCertificate: "上傳證明",
UploadedCertificate: "已上傳證明",
UploadFile: "上傳檔案",
UrbanCivision: "城市劃分",
USD: "美元",
UseCarCity: "用車城市",
UseCarDate: "用車日期",
UsedForCheckingInAtTheHotelFrontDeskOrForProcessingDestinationVisas: "用於在酒店前台辦理入住，或辦理目的地簽證時使用",
UseLxd: "使用",
UserCanceled: "用戶取消",
UserName: "用戶名",
UserNameEmailMobile: "12306用戶名/郵箱/手機號",
UseRules: "使用細則",
UseTheCarImmediately: "立即用車",
UseTravelCardTipsEnsureIdentityMatch: "·請確保常旅卡關聯的證件與登機時使用的證件相同。",
UseTravelCardTipsMilesDecidedByAirline: "·實際累積常旅卡及積分（里程）以航司執行為準。",
UseTravelCardTipsNoAutoMilesAccumulation: "當前行程航班不支持累積常旅客積分（里程）。",
UseTravelCardTipsPartialFlightsNotSupport: "·當前行程部分航班不支持累積常旅客積分（里程）。",
UsingTheAppFaceRecognitionIsMoreAccurateAndFaster: "使用app，人臉識別更準更快",
UsingTheLastestVersion: "您使用的已是最新版本",
ValidPeriod: "有效期至",
VehicleDisinfection: "車輛消毒",
VehicleTrack: "用車軌跡",
VerificationCode: "驗證碼",
VerificationCodeAgain: "重新獲取驗證碼",
VerificationCodeAgain_1: "重新獲取",
VerificationCodeCheck: "輸入簡訊驗證碼，完成核驗",
VerificationCodeCheckFail: "驗證碼校驗失敗",
VerificationCodeCoped: "驗證碼已複製",
VerificationCodeCopiedSuccessful: "驗證碼複製成功",
VerificationCodeFailedToSend: "驗證碼發送失敗",
VerificationCodeGet: "獲取驗證碼",
VerificationCodeHasBeenSent: "驗證碼已發送",
VerificationFail: "核驗失敗",
VerificationInProgress: "核驗中",
VerificationPass: "核驗通過",
VerificationPassLoginSuccess: "核驗通過，登入成功",
VerificationSucceeded: "校驗成功，通過！",
VerificationSuccessful: "核驗成功",
VerifiedPhoneNumber: "已通過核驗的手機號",
VerifyUsingMail: "使用郵箱驗證",
VerifyUsingPhoneNumber: "使用手機號驗證",
VerifyVehicleBeforeBoarding: "上車前請先核驗車輛信息",
VersionNumber: "版本號",
VersionUpdate: "版本更新",
ViewAllStaff: "可查看全部員工",
ViewBookPermissions: "查看/預訂權限",
ViewComments: "查看評論",
ViewComments_1: "查看點評",
ViewConfirmNumber: "查看確認單",
ViewDesignatedDepart: "可查看指定部門",
ViewDesignatedStaff: "可查看指定員工",
ViewDetailedProcedure: "查看詳細流程",
ViewDirectTicket: "查看直達車票",
ViewElectronicPolicy: "查看保單",
ViewHelpDocs: "查看說明文件",
ViewHistoricalApplys: "查看歷史申請單",
ViewHistoricalOrders: "查看歷史訂單",
ViewHistoryChat: "查看歷史對話",
ViewItineraryTrack: "查看行程軌跡",
ViewMoreCountriesOrRegions: "查看更多國家/地區",
ViewMoreFlights: "查看更多航班",
ViewMoreHotel: "查看更多飯店",
ViewMoreTrains: "檢視更多車次",
ViewMoreTransferSchemes: "查看中轉方案",
ViewOnlySelf: "僅限查看本人",
ViewOrder: "查看",
ViewPermissions: "查看權限",
ViewReimbursementVoucher: "查看報銷憑證",
ViewReservation: "查看預訂單",
ViewRoomType: "查看房型",
ViewSample: "查看樣例",
ViewTheBigMap: "查看大圖",
ViewTheLowestPrice: "查看最低價航班",
ViewTravelApplicationForm: "查看出差申請單",
ViolationOfBusTravelRank: "違反汽車票差旅標準，需要選擇的原因",
ViolationOfCarTravelRank: "違反用車差旅標準，需要選擇的原因。",
ViolationOfHomsomTravelStandardsNotSelectable: "違反貴司的差旅標準,不可選擇",
ViolationOfHomsomTravelStandardsSelectedReason: "違反貴司的差旅標準，需選擇原因：",
ViolationOfHotelTravelRank: "違反酒店差旅標準，需要選擇的原因",
ViolationOfMealsTravelRank: "違反用餐差旅標準，需要選擇的原因",
ViolationOfRank: "違反差標",
ViolationOfRankDetail: "違反差標詳情",
ViolationOfTrainTravelRank: "違反火車票差旅標準，需要選擇的原因",
ViolationOfTravelRank: "違反差旅標準",
VirtualNumberProtection: "虛擬號碼保護，避免手機號洩露",
Visa: "簽證",
VisaCountryOrRegion: "簽證國家/地區",
VisaDetails: "簽證詳情",
VisaIssuanceEmail: "出簽郵件",
VisaIssuanceShortMessage: "出簽簡訊",
VisaOrder: "簽證訂單",
VisaSubmissionEmail: "送簽郵件",
VisaSubmissionShortMessage: "送簽簡訊",
VisaType: "簽證類型",
VoiceTooShort: "說話聲音太短",
VoidApplicationForm: "作廢申請單",
VoidedFailed: "作廢失敗",
VoidedSuccessfully: "作廢成功",
VoluntaryRefund: "自願退票",
VoluntaryRefundDesc: "自願退票(按航空公司退改規則收費)",
VoluntaryRefundExplain: "自願退票說明",
VoluntaryReschedule: "自願改期",
VoluntaryRescheduleDesc: "自愿改期(按航空公司退改规则收费)",
VoluntaryRescheduleExplain: "自願改期說明",
Voucher: "抵用券",
WaitingForConfirmation: "等待確認",
WarmTipsWhitelistedEmployees: "溫馨提示: 白名單內員工，無需審批。",
WarmTipTheModificationIsNotSupportedForTheTimeBeing: "溫馨提示：暫不支持修改，如需修改請聯繫您的專屬顧問",
Wechat: "微信",
WeChat_Limit_1: "因小程序限制，請在恒順商旅APP或網站中進行該操作",
WechatByAccount: "企業微信帳號",
WechatByUser: "企業微信員工綁定",
WechatIsNotInstalled: "微信未安裝",
WechatNotSupportDDPleaseUseAppOrH5: "微信小程序暫不支持滴滴用車，請使用APP或H5預訂",
WechatNotSupportOnlineCheckInPleaseOpenOnPcOrApp: "微信小程序暫不支持線上值機，請使用PC、APP或H5開啟",
WechatPay: "微信支付",
WeekFri_1: "週五",
WeekMon_1: "週一",
WeekSat_1: "週六",
WeekSun_1: "週日",
WeekThur_1: "週四",
WeekTues_1: "週二",
WeekWed_1: "週三",
Welcome: "Hi，歡迎您！",
WelcomeBackChat: "歡迎回來，聊點新內容吧",
WelcomeToDidi: "歡迎使用滴滴出行",
WelcomeToHOMSOM: "歡迎來到恒順商旅",
WelcomeToHumanCustomerService: "歡迎進入人工客服",
WelcomeToLogin: "您好，歡迎登入。",
WelcomeToLoginHomsom: "歡迎登入恒順商旅",
WelcomeToUseIt: "歡迎使用",
WhatIsEnterpriseCode: "什麼是企業碼",
WhereWouldYouLikeToGo: "想要去哪裡？",
WhetherToAcceptTheSeatlessTicket: "當所選坐席餘票不足時,是否接受無座票",
WhetherToConfirmTheDeletionOfThisFavoriteContact: "確認刪除該常用聯絡人",
WhetherToConfirmThePasswordChange: "是否確認修改密碼？",
WhetherToConfirmTheRefund: "是否確認退票？",
WhetherToSendARefundEmail: "是否發送退票郵件",
WhetherToSendARefundEmail_1: "發送退票郵件",
WhetherToSendARefundSuccessfulMail: "是否發送退票成功郵件",
WhetherToSendARefundSuccessfulMail_1: "發送退票成功郵件",
WhetherToSendARefundSuccessfulSMS: "是否發送退票成功簡訊",
WhetherToSendARefundSuccessfulSMS_1: "發送退票成功簡訊",
WhyOpenEnterpriseCode: "為什麼開通企業碼",
WhyOpenEnterpriseCodeDescription: "開通企業碼後，即可在恆順商旅預訂火車票時使用「因公付（恆順商旅）」，費用直接由恆順商旅支付寶對公賬戶支付，無需員工個人墊資。",
Window_1: "靠窗",
WindowType: "窗戶",
Withdrawal: "提現",
WriteReasonCode: "填寫ReasonCode",
YearOnYear: "同比",
Yesterday: "前一天",
Yesterday_1: "昨天",
YouAlsoHaveUnselectedPassengers: "您還有未選座的乘客，請選座完成後再提交訂單！",
YouAreUsingAggregationPlatform: "您正在使用聚合平台",
YouAreUsingDiDiPlatform: "您正在使用滴滴平台",
YouCanDoTheFollowing: "您可以進行以下操作",
YouCannotSelectContactsWithTheSamePhoneNumberAtTheSameTime: "不得同時選擇手機號相同的聯絡人",
YouCanOnlyGetSMSVerificationCodesFor3MobilePhoneChecksPerDay: "*每個用戶1天僅能獲取3次手機核驗簡訊驗證碼",
YouCanOpenItInMySettingSecurityManager: "您可在我的-設置-安全管理中開通",
YouCanUseFaceIDVerification: "開啟後，可使用面容ID驗證，快速完成登入",
YouCanUseTouchIDVerification: "開啟後，可使用指紋ID驗證，快速完成登入",
YouHaveACarOrderInProgress: "您有一個用車訂單正在進行",
YouHaveToDoFaceRecognitionAlone: "必須一個人進行人臉識別",
YouHaveUnselectedPassengersPleaseSubmitAfterSeatSelection: "您有未選座的乘客，請選座完成後再提交",
YouNeedToPayViaAlipay: "您需要透過支付寶完成支付",
YouNotCompletedTheTrainTicketIdentityVerification: "您還未完成火車票人證核驗，是否現在去核驗？",
YourApplyHasNotBeenFilledOut: "您的出差申請尚未填寫完成，是否確定要離開當前頁面？",
YourCompanyAllowsYouToPayTheExtraAmountForAnOutPolicyHotelByCreditCardWeChatOrAlipay: "公司允許超額部分個人補貼，可用微信、支付寶支付超標部分。",
YourCurrentLoginAccountNeedsMobilePhoneNumberVerification: "您當前登入的帳號需進行手機號核驗",
YourDateOfBirthGenderNationalityAndIDCardDoNotMatch: "您的出生日期和性別國籍與身份證不符，已為您更正",
YourDateOfBirthGenderNationalityAndIDCardDoNotMatch_1: "您的出生日期或性別國籍與身份證不符",
YourExclusiveTravelConsultant: "您的專屬差旅顧問",
YourHotelGroupMembershipCard: "您的酒店集團會員卡",
YourOrderHasNotBeenCompletedOut: "您的訂單尚未完成,是否確定要離開目前頁面?",
YourOrderHasNotBeenFilledOut: "您的訂單尚未填寫完成,是否確定要離開目前頁面?",
YourPhoneNumberHasNotBeenRegisteredYet: "您的手機號碼還沒有註冊",
YourStayIsTooLongTheFlightAndPriceInformationMayChangeAndTheLatestPrice: "您的停留時間過長，航班及價格信息可能發生變動，正在為您查詢最新價格",
YourTravelCard: "您的常旅卡",
YouWill: "您將從",
YouWillFrom: "你將從",
About: "約",
And: "和",
Avg: "均",
B: "公",
BackTag: "返",
Below: "下",
Book: "订",
By: "经",
Change_1: "改",
CN: "中",
Copy: "份",
Cross: "过",
D: "始",
E: "终",
EN: "英",
Female: "女",
First: "第",
Floor: "层",
From: "起",
GoTag: "去",
Home_1: "家",
In: "住",
Male: "男",
Month: "月",
NoHistoryChat: "尚無歷史對話，快來提問吧～",
None: "无",
Original: "原",
Out: "离",
P: "私",
Page: "页",
QuantifierHotel: "间",
QuantifierNight: "晚",
QuantifierPeople: "人",
R: "退",
Rest: "休",
RMB: "元",
Save_1: "省",
ScoreByComments: "分",
Snatch: "抢",
Stop_1: "停",
Tax: "稅",
Tickets: "張",
To: "至",
TrainAvailable: "有",
TrainQuietCoach: "靜",
Transfer_1: "轉",
Unit_1: "個",
Upper: "上",
WeekFri: "五",
WeekMon: "一",
WeekSat: "六",
WeekSun: "日",
WeekThur: "四",
WeekTues: "二",
WeekWed: "三",
Window: "窗",
Work: "班",
Year: "年",
You: "您",
AccountProtocol_2_x: "您提供的姓名、手機號碼、身分證號碼等資訊將用於辦理12306帳號密碼找回及進階驗證的便捷服務，更多詳情請參閱%a$",
AccountProtocol_3_x_x: "根據《鐵路旅客車票實名制管理辦法的規定》，您在使用本平台購買火車票及相關服務時，須提交真實有效的身分證件資訊。該資訊將用於購票、乘車、退改簽、列印發票等行程相關環節。請確保資訊準確無誤，以免影響使用。我們將透過加密等安全措施保護您的個人資訊，僅在必要交易情境下授權提供給相關第三方。更多詳情請參閱%a$%b$",
ActualTotalPrice_x: "實際費用%a$",
AddDay_x: "+%a$天",
Adults_1_x: "%a$成人",
Adults_Children_x_x: "%a$成人 %b$孩童",
Adults_x: "成人%a$",
Age_x: "%a$歲",
AIAssistantIntro_x: "我是%a$的 AI 行程助理~",
AirportDropOff_x: "%a$接機",
AirportPickup_x: "%a$接機",
AllTime_x: "時間約%a$",
AllTime_x_x: "%a$，時間約%b$",
ApplicationContent_x: "申請內容: %a$",
Approval_x: "%a$審批",
ApprovalTimeoutNoticeTime: "審批超時通知時間：%a$分鐘",
AreYouSureToDelete_x: "確定要刪除%a$嗎？",
AreYouSureToRemove_x: "是否刪除該%a$",
AreYouSureYouWantToGiveUpTheInformationChange_x: "%a$ 有資訊變更，確認放棄修改？",
AToB_x_x: "%a$ 至 %b$",
AttachFileUpload_x: "可再傳%a$個",
Available_x: "%a$可用",
Baby_1_x: "%a$嬰兒",
Baby_x: "嬰兒%a$",
BackWeek_x: "%a$返回",
BaggageAllowance_x: "行李政策：%a$",
BasicInformationIsIncompletePleaseEdit_x: "%a$基本資訊不完整，請刪改",
BecomeDue_x: "%a$ 到期",
BedWide_x_x: "寬%a$ x %b$",
BindMembershioFor_X: "綁定%a$會籍卡",
BindPerson_x: "已綁定 %a$ 人",
BookDesignated_x: "為指定%a$預訂",
BookPwdRemainingAttempts_x: "還剩下%a$次機會。若忘記預訂密碼，請嘗試找回密碼。",
Budget_1_x: "%a$預算",
Budget_x: "預算%a$",
Business_x: "%a$(因公)",
CanAccommodateUpToXPeople_x: "每間客房最多可容納%a$人",
CanOnlySelectUpToXGuest_x: "每間房最多只能選擇 %a$ 位入住者",
CanOnlySelectUpToXpassengers_x_x: "最多只能選擇 %a$ 個 %b$",
CanPeopleStaying_x: "可容納%a$人",
CarUseEndDate_x: "用車結束日期可延長至：%a$",
CarUseStartDate_x: "用車起始日期可提前至：%a$",
ChangeStationWarn_1_x_x: "您的出發地已從 %a$ 變更為 %b$，是否繼續？",
ChangeStationWarn_2_x_x: "您的目的地已從 %a$ 變更為 %b$，是否繼續？",
ChangeStationWarn_x_x_x_x: "您的出發地已由 %a$ 變更為 %b$，目的地已由 %c$ 變更為 %d$，是否繼續？",
ChangeTheNumberOfPeople_x: "您所選的乘機人已變更，系統已為您調整為 %a$。若此設定不符合您的需求，您可以自行修改乘機人",
ChangeTheNumberOfRoomsAndPeople_x_x: "您所選的入住人數已變更，我們已調整為%a$間%b$人。若此安排不符合您的需求，您可以自行修改房間入住人數",
ChangeTo_x: "更改為%a$",
ChargebackNumber_x: "退單號%a$",
CheckIn_x: "%a$入住",
CheckInCheckOut_x_x_x: "%a$ 入住，%b$ 退房，%c$ 晚",
CheckInDate_x: "入住日期可提前至：%a$",
CheckInToCheckoutNight_x_x_x: "%a$ 至 %b$ %c$晚",
CheckInToCheckoutNight_x_x_x_x_x: "%a$ %b$ 入住，%c$ %d$ 退房，%e$ 晚",
CheckInToCheckoutNightAndRoom_x_x_x_x: "%a$ 至 %b$ · %c$晚%d$間",
CheckInToCheckoutNightAndRoomAndRoom_x_x_x_x_x: "%a$ 至 %b$ · %c$晚%d$間 · %e$",
CheckOut_x: "%a$退房",
CheckOutDate_x: "退房日期可延長至：%a$",
Children_1_x: "%a$孩童",
Children_x: "孩童%a$",
ChName_x: "中文名稱「%a$」",
ChNameToPinyin_x: "將「%a$」轉為拼音",
Choose_x: "選擇%a$",
ChooseAtLeastXPeople_x: "至少需選擇 %a$ 位入住者",
ChooseAtMostContact_x: "最多只能選擇 %a$ 位聯絡人",
ChooseUpToXPeople_x: "最多可選 %a$ 位入住者",
CNYStart_x: "%a$起",
CompanyAndPersonalPayment_1_x_x: "公司支付%a$，個人支付%b$",
CompanyAndPersonalPayment_x_x: "公司%a$ 個人%b$",
ConfirmFollow_x: "確認關注·%a$人",
ConfirmImportTraveler_x: "確認導入·%a$人",
ConfirmSelectedTraveler_x: "確認選擇·%a$人",
ContactEmailFormatIsIncorrect_x: "聯絡人%a$的電子郵件格式不正確",
ContactInformationOfExclusiveConsultant_x: "專屬顧問%a$的聯絡方式",
ContactMobileFormatIsIncorrect_x: "聯絡人%a$的手機號碼格式不正確",
Contacts_x: "聯絡人%a$",
ContactTheEmailNotificationHasBeenTurnedOn_x: "聯絡人%a$已啟用電子郵件通知功能，電子郵件地址不得為空！",
ContactTravelAdvisorOrCall_x: "請聯絡您的專屬差旅顧問或撥打%a$進行預訂",
ConvertToPinyin_x: "將「%a$」轉換為拼音",
CountFormat_x: "%a$個",
CurrencyExplain_x: "貨幣：%a$ 每位成人票價",
CurrentBoundAccountPrefix_x: "目前綁定帳號：%a$",
CurrentOrderGeneratedOrder_x: "本次下單共生成 %a$ 筆訂單",
CurrentOrderGeneratedOrderYouNeedToPayInTurn_x: "本次下單共生成 %a$ 筆訂單，您需依序付款",
CurrentPhoneNumberTip_x: "您的當前行動電話號碼為%a$，請輸入新的行動電話號碼並完成驗證。",
Departure_x: "%a$出發",
DepartureCityAndArrivalCityCannotBeSame_x: "第%a$程的出發城市與抵達城市不得相同",
DepEndDate_x: "出發與結束日期可延長至：%a$",
DepStartDate_x: "出發起始日期可提前至：%a$",
DesignatedDepartment_x: "指定的%a$",
DistanceCenter_x_x: "距離市中心%a$·%b$",
DistanceFromYou_x: "距離您%a$",
DistanceToDestination_x: "距離目的地%a$",
Download_x: "下載%a$",
Downloading_x: "正在下載中...%a$%",
EachRoomNeedsToFillIn_x: "每間需填寫%a$人",
EconomyClassDiscountBelow_x: "經濟艙 (%a$折及以下)",
Edit_x: "编辑%a$",
ElectronicInvoiceReissueLimit_x: "電子發票僅可重新開立%a$次，請仔細填寫發票資訊",
EmailFormatIsIncorrect_x: "%a$ 的電子郵件格式不正確",
EstimatedWaitingTime_x: "預計等待%a$分鐘",
ExclusiveConsultant_x: "專屬顧問%a$",
ExistingStaff_x: "已有员工(%a$)",
FileSizeLimit_x: "僅支援 %a$ Mb 以下的附件大小",
FldReward_x: "%a$個代金豆",
Flight_x: "%a$航班",
FlightNo_x: "航班號%a$",
Floor_x: "%a$層",
FlyingTime_x: "飛行 %a$",
GoingAndReturnTicket_x_x: "%a$(去程),%b$(回程)",
GoingTicket_x: "%a$(去程)",
GoTo_x: "前往%a$",
GoToMixedPay_x: "超額支付%a$",
GoToPay_1_x: "支付%a$",
GoToPay_x: "前往支付%a$",
GoToTheStoreBeforeOClock_x: "%a$ 抵達前",
GuestRoom_x: "房間%a$",
Hotel_x: "%a$飯店",
HotelChargeByPersonCountTip_x: "%a$ 飯店按人收費，請準確選擇成人及孩童人數",
HotelCheckInPost_x: "%a$入住後",
HotelCheckOutBefore_x: "%a$ 前退房",
HotelFillRoomGuestOptional_1_x: "填寫房間%a$住客",
HotelFillRoomGuestOptional_x: "填寫房間%a$住客（可選）",
HotelRefundRoomNight_x_x: "退%a$間·%b$晚",
IHaveReadAndAgree_x: "已閱讀並同意%a$",
Index_x: "%a$程",
Intergral_x: "%a$積分",
IntergralDeliveryNumber_x: "快遞單號：%a$",
Interval_x: "間隔%a$",
Inventory_x: "庫存：%a$件",
InvoiceDetailsCount_x: "開票明細共%a$張",
IsNotAArrivalCity_x: "%a$ 不能作為抵達城市",
IsNotADepartureCity_x: "%a$ 不能作為出發城市",
ItineraryInfo_x: "行程資訊%a$",
ItIsNowPastZeroOclock_x: "目前已過午夜12點，如需在凌晨%a$點前入住，請選擇「今天凌晨」入住",
JudgeCertificateExpired_x: "%a$ 當前證件有效期與起飛時間相較不足 6 個月，可能導致無法登機，是否繼續？",
KeySelectedCarTypes_x: "已選取 %a$ 款車型",
LengthMustNotExceedXDigits_x_x: "%a$長度不得超過%b$位",
LevelXAapproval_x: "%a$級審批",
LimitedToXReservation_x: "僅限%a$預訂",
LocalTimeOfTheDepartureCity_x: "航班號 %a$，請選擇出發地當地的時間",
Login12306AccountInPerson_x: "請確認您是本人：%a$",
LowestPriceHoursAndTicket_x_x: "過去 %a$ 小時最低價 %b$/張",
LxdReward_x: "%a$ 個旅行豆",
LxdToCompleteTheOrder_x: "完成訂單後可獲得 %a$ 個旅行豆",
Manage_x: "%a$管理",
MaxOnlyUseFld_x: "最多只能使用 %a$ 代金豆",
MaxSelectableOrders_x: "一次最多可選 %a$ 張",
MaxUseFld_x: "最多可使用 %a$ 代金豆",
MergeIssueReimbursableAmountInfo_x_x_x: "含 %a$ 張正單和 %b$ 張退改單，合併開立之可報銷金額為 %c$",
Minute_x: "%a$分鐘",
MixedPaymentContent_x_x_x: "您預訂的訂單總金額%a$，差旅標準上限為%b$，已超出%c$，您可以選擇自行支付超出部分，或選擇由公司全額支付。",
MixedPaymentDetails_x_x: "公司將支付%a$，超出差旅標準的金額需由個人自行負擔%b$",
MonthsCount: "%a$個月份",
MoreAvailable_x: "滿%a$元即可使用",
Name_x: "%a$姓名",
NearlyMonthApply_x: "近%a$個月的申請單",
NearlyMonthOrder_x: "近%a$個月的訂單",
New_x: "新增%a$",
NightsTotalPrice_x: "%a$總價",
NoMoreApply_x_x: "已顯示 %a$ 至 %b$ 的申請單",
NoMoreOrder_x_x: "已顯示 %a$ 至 %b$ 的訂單",
NoXSegment_1_x: "選擇第%a$程",
NoXSegment_2_x: "選為第%a$程",
NoXSegment_x: "第%a$程",
OnlyAlternativeTrainsCanBeSelectedAtMost_x: "最多只能選擇%a$個備選班次",
OnlyChineseName_x: "%a$只能使用中文名",
OnlyEnglishName_x: "%a$只能使用英文名",
OnlySupportsDataWithStatisticalDateSpanOfLessThanYears_x: "僅支援統計日期的跨度在%a$年以內的資料",
OpenedInYear_x: "%a$年開業",
OrderAndAmountSummary_x_x: "共 %a$ 個訂單，可開立金額 %b$",
OrderDetailTotalCount_x: "訂單詳情：共%a$張",
OrderNumber_x: "訂單號%a$",
OrdersNotSupportOnlineIssuing_x: "目前有%a$筆訂單暫不支援線上開票",
Other_x: "其他：%a$",
PayAtTheStore_x: "到店付%a$",
PayAtTheStoreAbout_x: "到店支付 約 %a$",
PayAtTheStoreTaxesFees_x: "到店另付稅/費 約%a$",
Pending_x: "待審核(%a$)",
People_x: "%a$人",
PeopleStaying_x: "%a$人入住",
Personal_x: "%a$(因私)",
PhoneNumberFormatIsIncorrect_x: "%a$的手機號格式不正確",
Plan_x: "原計畫%a$",
PleaseChooseOrInput_x: "請選擇/填寫%a$",
PleaseChooseRouteArrivalCity_x: "請選擇第%a$程抵達城市",
PleaseChooseRouteDepartCity_x: "請選擇第%a$程出發城市",
PleaseChooseRouteGoDate_x: "請選擇第%a$程出發時間",
PleaseCompleteTheInformation_x: "請補全%a$的資訊",
PleaseCompleteTheVerificationWithinMinutes_x: "請在%a$分鐘內完成核驗。",
PleaseEnter_x: "請輸入%a$",
PleaseEnterIDNumber_x: "請輸入%a$證件號碼",
PleaseEnterPhoneNumber_x: "請輸入%a$手機號",
PleaseEnterThe_x: "請輸入要查找的%a$",
PleaseFill_x: "請填寫%a$",
PleaseFill_x_x: "請填寫%a$的%b$",
PleaseFillBudget_x: "請填寫%a$的預算",
PleaseFillIn_x: "請輸入%a$名稱",
PleaseFillInEmail_x: "請填寫%a$的電子郵件",
PleaseFillInMobile_x: "請填寫%a$的手機號",
PleaseFillInTheContactMobilePhoneNumber_x: "請填寫聯絡人%a$的手機號",
PleaseFillOrChoose_x: "請填寫或選擇%a$",
PleaseReadAndAgreeTo_x: "請先閱讀並同意%a$",
PleaseReselect_x: "請重新選擇%a$",
PleaseSelect_x: "請選擇%a$",
PleaseSelect_x_x: "請選擇%a$的%b$",
PleaseSelectFlightChangeDate_x: "請選擇%a$航班改期日期",
PleaseSelectThePassengerWhoNeedsToRefund_x: "請選擇需要退票的%a$",
PleaseUploadAttachFile_x: "請上傳%a$",
PleaseWaitAtLocation_x: "請提前前往%a$等候上車",
PriceOfPerson_x_x: "%a$ X %b$人",
PricePerPerson_x: "%a$/人",
Punctuality_x: "準點率%a$",
PurchaseXItemAtMost_x: "限購%a$件",
QueryDateRange_x_x: "查詢日期範圍：%a$ 至 %b$",
Ready_x: "預計%a$",
ReasonsForBusiness_x: "出差事由：%a$",
RefundOrderInvoiceAmount_x_x: "共 %a$ 個退單，可開立金額 %b$",
RefundOrderNumber_1_x: "退單訂單號%a$",
RefundOrderNumber_x: "退票訂單號%a$",
ReimbursementVoucher_x: "%a$報銷憑證",
Remaining_1_x: "剩餘 %a$ 件",
Remaining_x: "剩%a$張",
RemainingCount_x: "剩%a$個",
RemainingRoom_x: "僅剩 %a$ 間",
RemainingUseLxd_x: "%a$個（1個旅行豆=1元人民幣）",
RemainRoom_x: "剩%a$間",
RemoveThe_x: "刪除該%a$",
RenovatedInYear_x: "%a$年裝修",
RequiredChoose_x: "需選擇 %a$ 人",
RequiredFill_x: "%a$必填",
Resend_x: "重新發送 %a$s",
ResendAfterXSeconds_x: "%a$ 秒後重新發送",
ResendPleaseWait_x: "重新發送請稍候 %a$",
ReturnEndDate_x: "返程結束日期可延長至：%a$",
ReturnStartDate_x: "返程起始日期可提前至：%a$",
ReturnTicket_x: "%a$(返程)",
RMB_x: "%a$元",
RMBPrice_x_x: "¥%a$-%b$",
RMBPriceOver_x: "¥%a$以上",
RMBPriceUnder_x: "¥%a$以下",
Room_x: "%a$間",
RoomAdult_x_x: "%a$ 間 %b$ 成人",
RoomAdult_x_x_x: "%a$ 間 %b$ 成人 %c$ 兒童",
RoomAndNight_x_x: "%a$ 間 %b$ 晚",
RoomGuest_x: "房間%a$入住人",
RoomNight_x_x: "%a$ 間 %b$ 晚",
RoomNightPrice_x_x: "%a$ 間·%b$ 晚",
RoomNoXAtLeastChooseOneRoomer_x: "房間%a$至少需選擇一位入住者",
RouteDepartDateCannotBeLessThanLastRoute_x_x: "第%a$程的出發時間不得早於第%b$程的出發時間",
SchemIndex_x: "方案%a$",
SchemIndexSelect_x: "方案%a$(已選中)",
Search_1_x: "搜尋%a$",
SecondAfter_x: "%a$s後",
SeeAll_x: "查看全部%a$個價格",
Segment_x: "行程%a$",
Select_1_x: "已選：%a$",
Select_x: "選%a$",
Selected_Train_codes_x: "已選取 %a$ 個備選班次",
Selected_x_x: "已選取 %a$ 個 %b$",
SelectedOrderCount_x: "已選取 %a$ 筆訂單",
SelectedRoomTip_x: "已選擇房間%a$",
SelectedTraveler_x: "已選：%a$人",
SendSMS_x: "我們已向 %a$ 發送了一則驗證簡訊，請輸入您收到的驗證碼。",
SendTo12306_x: "發送 %a$ 至 12306",
SendVerificationCodeTo12306ByMobilePhoneUpToTimesPerDay_x_x: "請使用手機%a$將驗證碼%b$發送至12306，每日最多發送3次",
ServiceFeePerPerson_x: "服務費 %a$/人",
ShareDescPaymentOnBehalf_x: "我在恒順商旅預訂了%a$，需要您為我付款。",
ShareTitlePaymentOnBehalf_x: "%a$希望你為他付款",
SnatchDeadline_x: "出發前%a$",
SnatchDeadlineHour_x: "出發前%a$小時",
SnatchDeadlineMinute_x: "出發前%a$分鐘",
SorryCouldNotFindIt_x: "抱歉，未找到「%a$」相關的內容",
SorryThereAreNoSearchResultsFor_x: "抱歉，沒有 %a$ 的搜尋結果。",
StationDropOff_x: "%a$送站",
StationPickup_x: "%a$接站",
StatisticsBy_x: "依%a$統計",
Stay_1_x_x: "%a$停留%b$",
Stay_2_x_x: "中轉%a$ 停留%b$",
Stay_3_x_x: "經停%a$ 停留%b$",
Stay_x: "停留%a$",
Stop_1_x: "%a$停",
Stop_2_x: "%a$個經停",
Stop_x: "經停%a$",
Superior_x: "上級%a$",
TakesOff_x: "%a$起飛",
TakesOffArrival_x_x: "%a$抵達, %b$起飛",
TaxPrice_x: "稅%a$",
TemplateCustomItemApproval_x: "審批流程將根據預訂時選擇的%a$來確定。",
TheAgeOfTheChild_x: "第%a$位孩童的年紀",
TheDateOfDepartureCannotBeEarlierThanThePreviousProcess_x: "%a$出發日期不得早於上一趟行程",
TheIdentityOfPassengerXHasNotBeenVerified_x: "乘車人(%a$)的身份資訊待核驗",
TheNextPageIsNotUnderOuControl_x: "下一頁面的內容不在我們控制範圍內，使用時請注意安全%a$",
TheVerificationCodeHasBeenSentTo_1_x: "驗證碼已發送至 %a$",
TheVerificationCodeHasBeenSentTo_x: "已將驗證碼發送至 %a$",
ThisOrderUseFld_x: "本單您可使用 %a$ 個代金豆",
ThisOrderUseLxd_x: "本單您可使用 %a$ 個旅行豆",
ThJourneyIsXAndIsExpectedToTakeXMinutes_x_x: "全程%a$公里，預計行駛%b$分鐘",
TicketRestrictions_x: "退改%a$起",
TicketRestrictions_x_x: "退改%a$%b$起",
Tickets_x: "%a$張",
TimesFormat_x: "%a$次",
Tomorrow_x: "翌日%a$點",
Total_x: "共%a$",
TotalAmount_x: "總金額%a$",
TotalCabinInfo_x: "共有 %a$ 筆航班資訊",
TotalDuration_x: "總長度%a$",
TotalNights: "%a$晚",
TotalNights_1: "共%a$晚",
TotalOfDay_x: "%a$天",
TotalPiece_x: "共%a$件",
TotalPrice_x: "總價%a$",
TotalTrip_x: "(共%a$程)",
TrainPreferQuietCoach_x: "請優先為我分配 %a$ 席位",
TrainTicketSmsVerification_x_x_x: "請通知乘車人（%a$）使用行動電話號碼 %b$，於30分鐘內向12306發送簡訊 %c$ 進行驗證。",
Transfer_1_x: "%a$轉",
Transfer_2_x: "%a$程中轉",
Transfer_3_x: "轉乘%a$",
Transfer_Stop_x_x: "%a$程中轉%a$個經停",
Transfer_x: "中轉%a$",
Traveler_x: "出差人員：%a$",
TripInfo_x_x_x: "%a$提供本次服務，全程%b$公里，耗時%c$分鐘",
UnbindConfirmationMessage_x: "解除綁定後，您將無法使用%a$快速登入等相關服務。確定要解除綁定嗎？",
Unit_1_x: "%a$份",
Unit_x: " x %a$份",
Unit_x_x: "%a$ x %b$份",
UnitNumber_x: "部門編號：%a$",
UnusedTicketTitle_x: "乘機人：%a$ 持有以下行程的未使用機票，您可以透過改期預訂當前行程，如需預訂，請點擊【去改期】按鈕進行操作。",
UseLxd_x: "最高可使用 %a$ 旅行豆",
UseTheCar_x: "%a$ 用車",
ValidationCertificateInformationNotPassed_x: "%a$ 證件資訊驗證未通過",
VerificationCodeAgain_1_x: "驗證碼已發送，請留意查收簡訊；若未收到，您可以%a$",
VerificationCodeAgain_x: "驗證碼已發送，請留意查收簡訊；若未收到，您可以%a$重新取得",
ViewDesignated_x: "可參閱指定%a$",
ViewOtherPrices_x: "查看其他 %a$ 個價格",
ViolationOfRankReason_x: "違反差旅標準的原因：%a$",
VoiceMaxDuration_x: "語音最長傳送 %a$s",
WaitingTime_x: "已等待時間 %a$",
Welcome_x: "%a$，欢迎您！",
Welcome_x_x: "%a$：%b$ 歡迎您！",
WholeRoute_x: "全程%a$",
XFormatIsIncorrect_x: "%a$格式不正確",
XHoursBeforeAndAfterTheLowestPrice_x: "過去 %a$ 小時內之最低價",
XIDIsWrong_x: "(%a$)證件資訊驗證未通過",
XIsUnderXyearsOld_x: "%a$未滿12歲",
XOfFlight_x: "航班%a$",
XTrips_x: "共%a$趟",
Year_x: "%a$年",
YourPassengersAreFullToDelete12306_x: "您的 12306 訂位已滿，刪除 %a$ 位乘客即可完成本次購票",
YuanStart_x: "%a$元起",
}